/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getPublicLectures = /* GraphQL */ `
  query GetPublicLectures(
    $eventId: ID!
    $type: [String]
    $topicId: ID
    $room: String
    $date: AWSDate
    $searchTerm: String
    $limit: Int
    $nextToken: String
  ) {
    getPublicLectures(
      eventId: $eventId
      type: $type
      topicId: $topicId
      room: $room
      date: $date
      searchTerm: $searchTerm
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slug
        slugHistory
        title {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        presentationLanguage
        imageUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        pdfDeUrl
        room
        companyBooth
        subjects {
          id
          __typename
        }
        speakers {
          id
          fullName
          avatar
          companyId
          companyName
          __typename
        }
        company {
          id
          slug
          slugHistory
          name
          industry
          logoUrl
          bannerUrl
          website
          phone
          email
          fax
          keywords
          boothNumbers
          __typename
        }
        topics {
          id
          __typename
        }
        eventId
        status
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getPublicLecture = /* GraphQL */ `
  query GetPublicLecture($id: ID!) {
    getPublicLecture(id: $id) {
      id
      slug
      slugHistory
      title {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      type
      startTime
      endTime
      dateTimes
      presentationLanguage
      imageUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      pdfDeUrl
      room
      companyBooth
      subjects {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      speakers {
        id
        fullName
        avatar
        avatarImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        companyId
        companyName
        __typename
      }
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      topics {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      eventId
      status
      __typename
    }
  }
`;
export const getPublicNews = /* GraphQL */ `
  query GetPublicNews($sortDirection: String, $limit: Int, $nextToken: String) {
    getPublicNews(
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slug
        slugHistory
        name {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        imageUrl
        previewImageUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        previewImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        topic {
          id
          __typename
        }
        company {
          id
          slug
          slugHistory
          name
          industry
          logoUrl
          bannerUrl
          website
          phone
          email
          fax
          keywords
          boothNumbers
          __typename
        }
        employee {
          id
          fullName
          avatar
          email
          phone
          __typename
        }
        createdAt
        isHero
        isHero2
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getPublicNewsItem = /* GraphQL */ `
  query GetPublicNewsItem($id: ID!) {
    getPublicNewsItem(id: $id) {
      id
      slug
      slugHistory
      name {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      imageUrl
      previewImageUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      previewImage {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      topic {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      employee {
        id
        fullName
        avatar
        avatarImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        email
        phone
        __typename
      }
      createdAt
      isHero
      isHero2
      __typename
    }
  }
`;
export const getPublicProducts = /* GraphQL */ `
  query GetPublicProducts(
    $searchTerm: String
    $sortDirection: String
    $limit: Int
    $nextToken: String
  ) {
    getPublicProducts(
      searchTerm: $searchTerm
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slug
        slugHistory
        name {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        imageUrl
        previewImageUrl
        images {
          __typename
        }
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        previewImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        gallery {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        pdfUrl
        file3DModel {
          url
          s3Path
          fileName
          type
          name
          __typename
        }
        type
        topic {
          id
          __typename
        }
        company {
          id
          slug
          slugHistory
          name
          industry
          logoUrl
          bannerUrl
          website
          phone
          email
          fax
          keywords
          boothNumbers
          __typename
        }
        employee {
          id
          fullName
          avatar
          email
          phone
          __typename
        }
        createdAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getPublicProduct = /* GraphQL */ `
  query GetPublicProduct($id: ID!) {
    getPublicProduct(id: $id) {
      id
      slug
      slugHistory
      name {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      imageUrl
      previewImageUrl
      images {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      previewImage {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      gallery {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      pdfUrl
      file3DModel {
        url
        s3Path
        fileName
        type
        name
        __typename
      }
      type
      topic {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      employee {
        id
        fullName
        avatar
        avatarImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        email
        phone
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const getPublicJobs = /* GraphQL */ `
  query GetPublicJobs(
    $searchTerm: String
    $sortDirection: String
    $limit: Int
    $nextToken: String
  ) {
    getPublicJobs(
      searchTerm: $searchTerm
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slug
        slugHistory
        name {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        imageUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        pdfUrl
        company {
          id
          slug
          slugHistory
          name
          industry
          logoUrl
          bannerUrl
          website
          phone
          email
          fax
          keywords
          boothNumbers
          __typename
        }
        employee {
          id
          fullName
          avatar
          email
          phone
          __typename
        }
        createdAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getPublicJob = /* GraphQL */ `
  query GetPublicJob($id: ID!) {
    getPublicJob(id: $id) {
      id
      slug
      slugHistory
      name {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      imageUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      pdfUrl
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      employee {
        id
        fullName
        avatar
        avatarImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        email
        phone
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const getPublicEvents = /* GraphQL */ `
  query GetPublicEvents(
    $timeFilter: String
    $industryId: ID
    $sortDirection: String
    $limit: Int
    $nextToken: String
  ) {
    getPublicEvents(
      timeFilter: $timeFilter
      industryId: $industryId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slug
        slugHistory
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        imageUrl
        logoUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        startDate
        endDate
        startTime
        endTime
        type
        status
        location {
          name
          street
          streetNumber
          city
          zip
          countryCode
          lat
          lng
          __typename
        }
        landingPageUrl
        floorPlanUrl
        programUrl
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          imageUrl
          __typename
        }
        highlights {
          mainVideoUrl
          __typename
        }
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getPublicEvent = /* GraphQL */ `
  query GetPublicEvent($id: ID!) {
    getPublicEvent(id: $id) {
      id
      slug
      slugHistory
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      imageUrl
      logoUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      logo {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      startDate
      endDate
      startTime
      endTime
      type
      status
      location {
        name
        street
        streetNumber
        city
        zip
        countryCode
        lat
        lng
        travelAndParkingNotice {
          language
          text
          __typename
        }
        __typename
      }
      landingPageUrl
      floorPlanUrl
      programUrl
      landingPageIntroText {
        language
        text
        __typename
      }
      landingPageProgramText {
        language
        text
        __typename
      }
      landingPageBookingText {
        language
        text
        __typename
      }
      heroBannerStats {
        language
        text
        __typename
      }
      infoTextExhibitors {
        language
        text
        __typename
      }
      infoTextVisitors {
        language
        text
        __typename
      }
      infoTextTravel {
        language
        text
        __typename
      }
      contactPersons {
        name
        department
        phone
        email
        imageUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        __typename
      }
      highlights {
        mainVideoUrl
        mainText {
          language
          text
          __typename
        }
        dailys {
          date
          videoUrls
          __typename
        }
        images {
          imageUrl
          tags
          __typename
        }
        videos {
          videoUrl
          tags
          __typename
        }
        pressMedia {
          mediaUrls
          __typename
        }
        exhibitorInfo {
          __typename
        }
        __typename
      }
      daySchedules {
        day
        date
        exhibitorStart
        exhibitorEnd
        visitorStart
        visitorEnd
        note {
          language
          text
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getPublicCompanies = /* GraphQL */ `
  query GetPublicCompanies(
    $searchTerm: String
    $attendingEventId: [ID]
    $limit: Int
    $nextToken: String
  ) {
    getPublicCompanies(
      searchTerm: $searchTerm
      attendingEventId: $attendingEventId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getPublicCompany = /* GraphQL */ `
  query GetPublicCompany($id: ID!) {
    getPublicCompany(id: $id) {
      id
      slug
      slugHistory
      name
      description {
        language
        text
        __typename
      }
      shortDescription {
        language
        text
        __typename
      }
      industry
      logoUrl
      bannerUrl
      logo {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      banner {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      website
      phone
      email
      fax
      address {
        street
        streetNumber
        city
        zip
        countryCode
        __typename
      }
      keywords
      topics {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      boothNumbers
      news {
        items {
          id
          slug
          slugHistory
          imageUrl
          previewImageUrl
          createdAt
          isHero
          isHero2
          __typename
        }
        nextToken
        total
        __typename
      }
      lectures {
        items {
          id
          slug
          slugHistory
          type
          startTime
          endTime
          dateTimes
          presentationLanguage
          imageUrl
          pdfDeUrl
          room
          companyBooth
          eventId
          status
          __typename
        }
        nextToken
        total
        __typename
      }
      products {
        items {
          id
          slug
          slugHistory
          imageUrl
          previewImageUrl
          pdfUrl
          type
          createdAt
          __typename
        }
        nextToken
        total
        __typename
      }
      jobs {
        items {
          id
          slug
          slugHistory
          imageUrl
          pdfUrl
          createdAt
          __typename
        }
        nextToken
        total
        __typename
      }
      __typename
    }
  }
`;
export const getPublicLectureBySlug = /* GraphQL */ `
  query GetPublicLectureBySlug($slug: String!) {
    getPublicLectureBySlug(slug: $slug) {
      id
      slug
      slugHistory
      title {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      type
      startTime
      endTime
      dateTimes
      presentationLanguage
      imageUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      pdfDeUrl
      room
      companyBooth
      subjects {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      speakers {
        id
        fullName
        avatar
        avatarImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        companyId
        companyName
        __typename
      }
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      topics {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      eventId
      status
      __typename
    }
  }
`;
export const getPublicNewsItemBySlug = /* GraphQL */ `
  query GetPublicNewsItemBySlug($slug: String!) {
    getPublicNewsItemBySlug(slug: $slug) {
      id
      slug
      slugHistory
      name {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      imageUrl
      previewImageUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      previewImage {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      topic {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      employee {
        id
        fullName
        avatar
        avatarImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        email
        phone
        __typename
      }
      createdAt
      isHero
      isHero2
      __typename
    }
  }
`;
export const getPublicProductBySlug = /* GraphQL */ `
  query GetPublicProductBySlug($slug: String!) {
    getPublicProductBySlug(slug: $slug) {
      id
      slug
      slugHistory
      name {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      imageUrl
      previewImageUrl
      images {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      previewImage {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      gallery {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      pdfUrl
      file3DModel {
        url
        s3Path
        fileName
        type
        name
        __typename
      }
      type
      topic {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      employee {
        id
        fullName
        avatar
        avatarImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        email
        phone
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const getPublicJobBySlug = /* GraphQL */ `
  query GetPublicJobBySlug($slug: String!) {
    getPublicJobBySlug(slug: $slug) {
      id
      slug
      slugHistory
      name {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      imageUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      pdfUrl
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      employee {
        id
        fullName
        avatar
        avatarImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        email
        phone
        __typename
      }
      createdAt
      __typename
    }
  }
`;
export const getPublicEventBySlug = /* GraphQL */ `
  query GetPublicEventBySlug($slug: String!) {
    getPublicEventBySlug(slug: $slug) {
      id
      slug
      slugHistory
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      imageUrl
      logoUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      logo {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      startDate
      endDate
      startTime
      endTime
      type
      status
      location {
        name
        street
        streetNumber
        city
        zip
        countryCode
        lat
        lng
        travelAndParkingNotice {
          language
          text
          __typename
        }
        __typename
      }
      landingPageUrl
      floorPlanUrl
      programUrl
      landingPageIntroText {
        language
        text
        __typename
      }
      landingPageProgramText {
        language
        text
        __typename
      }
      landingPageBookingText {
        language
        text
        __typename
      }
      heroBannerStats {
        language
        text
        __typename
      }
      infoTextExhibitors {
        language
        text
        __typename
      }
      infoTextVisitors {
        language
        text
        __typename
      }
      infoTextTravel {
        language
        text
        __typename
      }
      contactPersons {
        name
        department
        phone
        email
        imageUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        __typename
      }
      highlights {
        mainVideoUrl
        mainText {
          language
          text
          __typename
        }
        dailys {
          date
          videoUrls
          __typename
        }
        images {
          imageUrl
          tags
          __typename
        }
        videos {
          videoUrl
          tags
          __typename
        }
        pressMedia {
          mediaUrls
          __typename
        }
        exhibitorInfo {
          __typename
        }
        __typename
      }
      daySchedules {
        day
        date
        exhibitorStart
        exhibitorEnd
        visitorStart
        visitorEnd
        note {
          language
          text
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
export const getPublicCompanyBySlug = /* GraphQL */ `
  query GetPublicCompanyBySlug($slug: String!) {
    getPublicCompanyBySlug(slug: $slug) {
      id
      slug
      slugHistory
      name
      description {
        language
        text
        __typename
      }
      shortDescription {
        language
        text
        __typename
      }
      industry
      logoUrl
      bannerUrl
      logo {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      banner {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      website
      phone
      email
      fax
      address {
        street
        streetNumber
        city
        zip
        countryCode
        __typename
      }
      keywords
      topics {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      boothNumbers
      news {
        items {
          id
          slug
          slugHistory
          imageUrl
          previewImageUrl
          createdAt
          isHero
          isHero2
          __typename
        }
        nextToken
        total
        __typename
      }
      lectures {
        items {
          id
          slug
          slugHistory
          type
          startTime
          endTime
          dateTimes
          presentationLanguage
          imageUrl
          pdfDeUrl
          room
          companyBooth
          eventId
          status
          __typename
        }
        nextToken
        total
        __typename
      }
      products {
        items {
          id
          slug
          slugHistory
          imageUrl
          previewImageUrl
          pdfUrl
          type
          createdAt
          __typename
        }
        nextToken
        total
        __typename
      }
      jobs {
        items {
          id
          slug
          slugHistory
          imageUrl
          pdfUrl
          createdAt
          __typename
        }
        nextToken
        total
        __typename
      }
      __typename
    }
  }
`;
export const getPublicSitemap = /* GraphQL */ `
  query GetPublicSitemap($industryId: ID!) {
    getPublicSitemap(industryId: $industryId) {
      generatedAt
      industryId
      companies {
        slug
        updatedAt
        __typename
      }
      products {
        slug
        updatedAt
        __typename
      }
      news {
        slug
        updatedAt
        __typename
      }
      lectures {
        slug
        updatedAt
        __typename
      }
      jobs {
        slug
        updatedAt
        __typename
      }
      events {
        slug
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const getPublicMediaSeries = /* GraphQL */ `
  query GetPublicMediaSeries(
    $industryId: ID
    $type: String
    $limit: Int
    $nextToken: String
  ) {
    getPublicMediaSeries(
      industryId: $industryId
      type: $type
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slug
        slugHistory
        type
        title {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        host
        industryId
        sortKey
        coverImageUrl
        coverImage {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        itemCount
        items {
          id
          slug
          slugHistory
          seriesId
          seriesSlug
          seriesType
          episodeNumber
          topic
          publishedAt
          isHero
          guest
          guestEmail
          guestPhone
          host
          speaker
          companyName
          companyUrl
          imageUrl
          audioUrl
          videoUrl
          externalVideoUrl
          videoEmbedUrl
          videoProvider
          spotifyUrl
          podigeeUrl
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getPublicMediaSeriesById = /* GraphQL */ `
  query GetPublicMediaSeriesById($id: ID!) {
    getPublicMediaSeriesById(id: $id) {
      id
      slug
      slugHistory
      type
      title {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      host
      industryId
      sortKey
      coverImageUrl
      coverImage {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      itemCount
      items {
        id
        slug
        slugHistory
        seriesId
        seriesSlug
        seriesTitle {
          language
          text
          __typename
        }
        seriesType
        title {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        contentPlain {
          language
          text
          __typename
        }
        episodeNumber
        topic
        publishedAt
        isHero
        guest
        guestEmail
        guestPhone
        host
        speaker
        companyName
        companyUrl
        company {
          id
          slug
          slugHistory
          name
          industry
          logoUrl
          bannerUrl
          website
          phone
          email
          fax
          keywords
          boothNumbers
          __typename
        }
        imageUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        audioUrl
        audio {
          url
          s3Path
          fileName
          type
          name
          __typename
        }
        videoUrl
        video {
          url
          s3Path
          fileName
          type
          name
          __typename
        }
        externalVideoUrl
        videoEmbedUrl
        videoProvider
        spotifyUrl
        podigeeUrl
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getPublicMediaSeriesBySlug = /* GraphQL */ `
  query GetPublicMediaSeriesBySlug($slug: String!) {
    getPublicMediaSeriesBySlug(slug: $slug) {
      id
      slug
      slugHistory
      type
      title {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      host
      industryId
      sortKey
      coverImageUrl
      coverImage {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      itemCount
      items {
        id
        slug
        slugHistory
        seriesId
        seriesSlug
        seriesTitle {
          language
          text
          __typename
        }
        seriesType
        title {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        contentPlain {
          language
          text
          __typename
        }
        episodeNumber
        topic
        publishedAt
        isHero
        guest
        guestEmail
        guestPhone
        host
        speaker
        companyName
        companyUrl
        company {
          id
          slug
          slugHistory
          name
          industry
          logoUrl
          bannerUrl
          website
          phone
          email
          fax
          keywords
          boothNumbers
          __typename
        }
        imageUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        audioUrl
        audio {
          url
          s3Path
          fileName
          type
          name
          __typename
        }
        videoUrl
        video {
          url
          s3Path
          fileName
          type
          name
          __typename
        }
        externalVideoUrl
        videoEmbedUrl
        videoProvider
        spotifyUrl
        podigeeUrl
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getPublicMediaItems = /* GraphQL */ `
  query GetPublicMediaItems(
    $seriesId: ID
    $seriesSlug: String
    $type: String
    $industryId: ID
    $sortDirection: String
    $limit: Int
    $nextToken: String
  ) {
    getPublicMediaItems(
      seriesId: $seriesId
      seriesSlug: $seriesSlug
      type: $type
      industryId: $industryId
      sortDirection: $sortDirection
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        slug
        slugHistory
        seriesId
        seriesSlug
        seriesTitle {
          language
          text
          __typename
        }
        seriesType
        title {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        contentPlain {
          language
          text
          __typename
        }
        episodeNumber
        topic
        publishedAt
        isHero
        guest
        guestEmail
        guestPhone
        host
        speaker
        companyName
        companyUrl
        company {
          id
          slug
          slugHistory
          name
          industry
          logoUrl
          bannerUrl
          website
          phone
          email
          fax
          keywords
          boothNumbers
          __typename
        }
        imageUrl
        image {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        audioUrl
        audio {
          url
          s3Path
          fileName
          type
          name
          __typename
        }
        videoUrl
        video {
          url
          s3Path
          fileName
          type
          name
          __typename
        }
        externalVideoUrl
        videoEmbedUrl
        videoProvider
        spotifyUrl
        podigeeUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      __typename
    }
  }
`;
export const getPublicMediaItem = /* GraphQL */ `
  query GetPublicMediaItem($id: ID!) {
    getPublicMediaItem(id: $id) {
      id
      slug
      slugHistory
      seriesId
      seriesSlug
      seriesTitle {
        language
        text
        __typename
      }
      seriesType
      title {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      contentPlain {
        language
        text
        __typename
      }
      episodeNumber
      topic
      publishedAt
      isHero
      guest
      guestEmail
      guestPhone
      host
      speaker
      companyName
      companyUrl
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      imageUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      audioUrl
      audio {
        url
        s3Path
        fileName
        type
        name
        __typename
      }
      videoUrl
      video {
        url
        s3Path
        fileName
        type
        name
        __typename
      }
      externalVideoUrl
      videoEmbedUrl
      videoProvider
      spotifyUrl
      podigeeUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getPublicMediaItemBySlug = /* GraphQL */ `
  query GetPublicMediaItemBySlug($slug: String!, $seriesSlug: String) {
    getPublicMediaItemBySlug(slug: $slug, seriesSlug: $seriesSlug) {
      id
      slug
      slugHistory
      seriesId
      seriesSlug
      seriesTitle {
        language
        text
        __typename
      }
      seriesType
      title {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      contentPlain {
        language
        text
        __typename
      }
      episodeNumber
      topic
      publishedAt
      isHero
      guest
      guestEmail
      guestPhone
      host
      speaker
      companyName
      companyUrl
      company {
        id
        slug
        slugHistory
        name
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        logoUrl
        bannerUrl
        logo {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        banner {
          url
          src
          srcSet
          width
          height
          alt
          format
          __typename
        }
        website
        phone
        email
        fax
        address {
          street
          streetNumber
          city
          zip
          countryCode
          __typename
        }
        keywords
        topics {
          id
          __typename
        }
        boothNumbers
        news {
          nextToken
          total
          __typename
        }
        lectures {
          nextToken
          total
          __typename
        }
        products {
          nextToken
          total
          __typename
        }
        jobs {
          nextToken
          total
          __typename
        }
        __typename
      }
      imageUrl
      image {
        url
        src
        srcSet
        width
        height
        alt
        format
        __typename
      }
      audioUrl
      audio {
        url
        s3Path
        fileName
        type
        name
        __typename
      }
      videoUrl
      video {
        url
        s3Path
        fileName
        type
        name
        __typename
      }
      externalVideoUrl
      videoEmbedUrl
      videoProvider
      spotifyUrl
      podigeeUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const getCourse = /* GraphQL */ `
  query GetCourse($id: ID!) {
    getCourse(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      sortKey
      lectures {
        items {
          id
          courseId
          lectureId
          createdAt
          updatedAt
          usersCanEdit
          __typename
        }
        nextToken
        __typename
      }
      videos
      shortDescription {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      type
      duration
      price
      topics {
        language
        text
        __typename
      }
      speakersDescription {
        language
        text
        __typename
      }
      CTADescription {
        language
        text
        __typename
      }
      CTABulletPoints {
        text {
          language
          text
          __typename
        }
        __typename
      }
      WPJetEngineId
      academyTopics {
        items {
          id
          courseId
          academyTopicId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCourses = /* GraphQL */ `
  query ListCourses(
    $filter: ModelCourseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCourses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        sortKey
        lectures {
          nextToken
          __typename
        }
        videos
        shortDescription {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        type
        duration
        price
        topics {
          language
          text
          __typename
        }
        speakersDescription {
          language
          text
          __typename
        }
        CTADescription {
          language
          text
          __typename
        }
        CTABulletPoints {
          __typename
        }
        WPJetEngineId
        academyTopics {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAcademyTopic = /* GraphQL */ `
  query GetAcademyTopic($id: ID!) {
    getAcademyTopic(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      color
      sortKey
      academyTopicGroup {
        id
        name {
          language
          text
          __typename
        }
        color
        sortKey
        academyTopics {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      courses {
        items {
          id
          courseId
          academyTopicId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      seminars {
        items {
          id
          academyTopicId
          seminarId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      academyTopicGroupAcademyTopicsId
      __typename
    }
  }
`;
export const listAcademyTopics = /* GraphQL */ `
  query ListAcademyTopics(
    $filter: ModelAcademyTopicFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAcademyTopics(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        color
        sortKey
        academyTopicGroup {
          id
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        courses {
          nextToken
          __typename
        }
        seminars {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        academyTopicGroupAcademyTopicsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAcademyTopicGroup = /* GraphQL */ `
  query GetAcademyTopicGroup($id: ID!) {
    getAcademyTopicGroup(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      color
      sortKey
      academyTopics {
        items {
          id
          color
          sortKey
          createdAt
          updatedAt
          academyTopicGroupAcademyTopicsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAcademyTopicGroups = /* GraphQL */ `
  query ListAcademyTopicGroups(
    $filter: ModelAcademyTopicGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAcademyTopicGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name {
          language
          text
          __typename
        }
        color
        sortKey
        academyTopics {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSeminar = /* GraphQL */ `
  query GetSeminar($id: ID!) {
    getSeminar(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      shortDescription {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      cover {
        fileName
        alt
        x4UUID
        __typename
      }
      seminarDays {
        date
        startTime
        endTime
        notice {
          language
          text
          __typename
        }
        __typename
      }
      location {
        name {
          language
          text
          __typename
        }
        travelAndParkingNotice {
          language
          text
          __typename
        }
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        coordinates {
          lat
          lng
          __typename
        }
        __typename
      }
      lectures {
        items {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        nextToken
        __typename
      }
      speakers {
        items {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        nextToken
        __typename
      }
      CTABulletPoints {
        text {
          language
          text
          __typename
        }
        __typename
      }
      bookingStartDate
      bookingEndDate
      product {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      academyTopics {
        items {
          id
          academyTopicId
          seminarId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      status
      sortKey
      WPJetEngineId
      createdAt
      updatedAt
      seminarProductId
      __typename
    }
  }
`;
export const listSeminars = /* GraphQL */ `
  query ListSeminars(
    $filter: ModelSeminarFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSeminars(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        cover {
          fileName
          alt
          x4UUID
          __typename
        }
        seminarDays {
          date
          startTime
          endTime
          __typename
        }
        location {
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        speakers {
          nextToken
          __typename
        }
        CTABulletPoints {
          __typename
        }
        bookingStartDate
        bookingEndDate
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        academyTopics {
          nextToken
          __typename
        }
        status
        sortKey
        WPJetEngineId
        createdAt
        updatedAt
        seminarProductId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTicket = /* GraphQL */ `
  query GetTicket($id: ID!) {
    getTicket(id: $id) {
      owner
      id
      industryId
      user {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      createdByUserId
      userTicketsId
      eventDays
      status
      paymentStatus
      type
      visitorType
      addons
      payment {
        id
        orderFinancial {
          id
          isBusiness
          isInterEUDelivery
          currency
          invoiceAmount
          invoiceAmountNet
          invoiceNumber
          invoiceDate
          invoiceLastSent
          invoiceReceivers
          servicePeriodStart
          servicePeriodEnd
          taxRate
          shippingCost
          shippingCostNet
          paymentCost
          discountCode
          discountAmount
          discountType
          paymentProvider
          stripeSessionId
          totalAmount
          createdAt
          updatedAt
          orderFinancialOrderId
          __typename
        }
        status
        isPayed
        amount
        currency
        paymentProvider
        transactionId
        paymentDate
        paymentAmount
        paymentCurrency
        createdAt
        updatedAt
        orderFinancialPaymentsId
        __typename
      }
      ticketFile {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      notes
      billingAddress {
        firstName
        lastName
        title
        salutation
        street
        street2
        streetNumber
        company
        contactPerson
        city
        zip
        countryCode
        __typename
      }
      billingEmail
      invitationCode
      orderNumber
      firstName
      lastName
      companyName
      scans {
        items {
          id
          scannedAt
          scannedLocation
          scannedDevice
          createdAt
          updatedAt
          ticketScansId
          owner
          __typename
        }
        nextToken
        __typename
      }
      personalAddress {
        firstName
        lastName
        title
        salutation
        street
        street2
        streetNumber
        company
        contactPerson
        city
        zip
        countryCode
        __typename
      }
      personalContact {
        phone
        mobile
        fax
        email
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        __typename
      }
      isFreeTicket
      createdAt
      updatedAt
      ticketEventId
      ticketCompanyId
      ticketPaymentId
      __typename
    }
  }
`;
export const listTickets = /* GraphQL */ `
  query ListTickets(
    $filter: ModelTicketFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTickets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        owner
        id
        industryId
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        createdByUserId
        userTicketsId
        eventDays
        status
        paymentStatus
        type
        visitorType
        addons
        payment {
          id
          status
          isPayed
          amount
          currency
          paymentProvider
          transactionId
          paymentDate
          paymentAmount
          paymentCurrency
          createdAt
          updatedAt
          orderFinancialPaymentsId
          __typename
        }
        ticketFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        notes
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        invitationCode
        orderNumber
        firstName
        lastName
        companyName
        scans {
          nextToken
          __typename
        }
        personalAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        personalContact {
          phone
          mobile
          fax
          email
          __typename
        }
        isFreeTicket
        createdAt
        updatedAt
        ticketEventId
        ticketCompanyId
        ticketPaymentId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchTickets = /* GraphQL */ `
  query SearchTickets(
    $filter: SearchableTicketFilterInput
    $sort: [SearchableTicketSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableTicketAggregationInput]
  ) {
    searchTickets(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        owner
        id
        industryId
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        createdByUserId
        userTicketsId
        eventDays
        status
        paymentStatus
        type
        visitorType
        addons
        payment {
          id
          status
          isPayed
          amount
          currency
          paymentProvider
          transactionId
          paymentDate
          paymentAmount
          paymentCurrency
          createdAt
          updatedAt
          orderFinancialPaymentsId
          __typename
        }
        ticketFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        notes
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        invitationCode
        orderNumber
        firstName
        lastName
        companyName
        scans {
          nextToken
          __typename
        }
        personalAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        personalContact {
          phone
          mobile
          fax
          email
          __typename
        }
        isFreeTicket
        createdAt
        updatedAt
        ticketEventId
        ticketCompanyId
        ticketPaymentId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getTicketScan = /* GraphQL */ `
  query GetTicketScan($id: ID!) {
    getTicketScan(id: $id) {
      id
      ticket {
        owner
        id
        industryId
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        createdByUserId
        userTicketsId
        eventDays
        status
        paymentStatus
        type
        visitorType
        addons
        payment {
          id
          status
          isPayed
          amount
          currency
          paymentProvider
          transactionId
          paymentDate
          paymentAmount
          paymentCurrency
          createdAt
          updatedAt
          orderFinancialPaymentsId
          __typename
        }
        ticketFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        notes
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        invitationCode
        orderNumber
        firstName
        lastName
        companyName
        scans {
          nextToken
          __typename
        }
        personalAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        personalContact {
          phone
          mobile
          fax
          email
          __typename
        }
        isFreeTicket
        createdAt
        updatedAt
        ticketEventId
        ticketCompanyId
        ticketPaymentId
        __typename
      }
      scannedAt
      scannedLocation
      scannedDevice
      createdAt
      updatedAt
      ticketScansId
      owner
      __typename
    }
  }
`;
export const listTicketScans = /* GraphQL */ `
  query ListTicketScans(
    $filter: ModelTicketScanFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTicketScans(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ticket {
          owner
          id
          industryId
          createdByUserId
          userTicketsId
          eventDays
          status
          paymentStatus
          type
          visitorType
          addons
          notes
          billingEmail
          invitationCode
          orderNumber
          firstName
          lastName
          companyName
          isFreeTicket
          createdAt
          updatedAt
          ticketEventId
          ticketCompanyId
          ticketPaymentId
          __typename
        }
        scannedAt
        scannedLocation
        scannedDevice
        createdAt
        updatedAt
        ticketScansId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getInvitationCode = /* GraphQL */ `
  query GetInvitationCode($id: ID!) {
    getInvitationCode(id: $id) {
      id
      createdByAdmin
      code
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      discountCode {
        id
        code
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        discountType
        discountAmount
        discountPercentage
        maxUsage
        usageCount
        startDate
        endDate
        status
        restrictedProductIds
        canBeCombined
        type
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      companyInvitationCodesId
      eventInvitationCodesId
      invitationCodeDiscountCodeId
      owner
      __typename
    }
  }
`;
export const listInvitationCodes = /* GraphQL */ `
  query ListInvitationCodes(
    $filter: ModelInvitationCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvitationCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdByAdmin
        code
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        discountCode {
          id
          code
          discountType
          discountAmount
          discountPercentage
          maxUsage
          usageCount
          startDate
          endDate
          status
          restrictedProductIds
          canBeCombined
          type
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        companyInvitationCodesId
        eventInvitationCodesId
        invitationCodeDiscountCodeId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const invitationCodeByCode = /* GraphQL */ `
  query InvitationCodeByCode(
    $code: String!
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvitationCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invitationCodeByCode(
      code: $code
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdByAdmin
        code
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        discountCode {
          id
          code
          discountType
          discountAmount
          discountPercentage
          maxUsage
          usageCount
          startDate
          endDate
          status
          restrictedProductIds
          canBeCombined
          type
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        companyInvitationCodesId
        eventInvitationCodesId
        invitationCodeDiscountCodeId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrder = /* GraphQL */ `
  query GetOrder($id: ID!) {
    getOrder(id: $id) {
      id
      industry {
        id
        name {
          language
          text
          __typename
        }
        subTitle {
          language
          text
          __typename
        }
        handle
        domain
        notificationEmailAddress
        primaryColor
        secondaryColor
        logo {
          fileName
          alt
          x4UUID
          __typename
        }
        favicon {
          fileName
          alt
          x4UUID
          __typename
        }
        sortKey
        status
        socialLinks {
          facebook
          x
          instagram
          spotify
          linkedin
          xing
          youtube
          pinterest
          snapchat
          tiktok
          __typename
        }
        events {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        orders {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        jetEngineAccess {
          baseurl
          username
          password
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      type
      orderNumber
      buyerOrderNumber
      user {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      status
      paymentStatus
      deliveryStatus
      products {
        items {
          id
          orderId
          productId
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      lineItems {
        items {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        nextToken
        __typename
      }
      notes
      deliveryAddress {
        firstName
        lastName
        title
        salutation
        street
        street2
        streetNumber
        company
        contactPerson
        city
        zip
        countryCode
        __typename
      }
      billingAddress {
        firstName
        lastName
        title
        salutation
        street
        street2
        streetNumber
        company
        contactPerson
        city
        zip
        countryCode
        __typename
      }
      billingEmail
      financial {
        id
        isBusiness
        isInterEUDelivery
        vatInfo {
          vatNumber
          country
          __typename
        }
        currency
        documents {
          documentType
          s3Path
          documentNumber
          referingDocumentNumber
          documentName
          status
          date
          amount
          amountNet
          sentToCustomerTime
          sentToCustomerAddresses
          lineItemIds
          __typename
        }
        invoiceAmount
        invoiceAmountNet
        invoiceNumber
        invoiceDate
        invoiceFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        invoiceLastSent
        invoiceReceivers
        servicePeriodStart
        servicePeriodEnd
        taxRate
        shippingCost
        shippingCostNet
        paymentCost
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        payments {
          nextToken
          __typename
        }
        discountCode
        discountAmount
        discountType
        paymentProvider
        stripeSessionId
        totalAmount
        createdAt
        updatedAt
        orderFinancialOrderId
        __typename
      }
      data
      totalAmount
      createdAt
      updatedAt
      industryOrdersId
      companyOrdersId
      userOrdersId
      eventOrdersId
      orderFinancialId
      owner
      __typename
    }
  }
`;
export const listOrders = /* GraphQL */ `
  query ListOrders(
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        type
        orderNumber
        buyerOrderNumber
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        paymentStatus
        deliveryStatus
        products {
          nextToken
          __typename
        }
        lineItems {
          nextToken
          __typename
        }
        notes
        deliveryAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        financial {
          id
          isBusiness
          isInterEUDelivery
          currency
          invoiceAmount
          invoiceAmountNet
          invoiceNumber
          invoiceDate
          invoiceLastSent
          invoiceReceivers
          servicePeriodStart
          servicePeriodEnd
          taxRate
          shippingCost
          shippingCostNet
          paymentCost
          discountCode
          discountAmount
          discountType
          paymentProvider
          stripeSessionId
          totalAmount
          createdAt
          updatedAt
          orderFinancialOrderId
          __typename
        }
        data
        totalAmount
        createdAt
        updatedAt
        industryOrdersId
        companyOrdersId
        userOrdersId
        eventOrdersId
        orderFinancialId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchOrders = /* GraphQL */ `
  query SearchOrders(
    $filter: SearchableOrderFilterInput
    $sort: [SearchableOrderSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableOrderAggregationInput]
  ) {
    searchOrders(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        type
        orderNumber
        buyerOrderNumber
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        paymentStatus
        deliveryStatus
        products {
          nextToken
          __typename
        }
        lineItems {
          nextToken
          __typename
        }
        notes
        deliveryAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        financial {
          id
          isBusiness
          isInterEUDelivery
          currency
          invoiceAmount
          invoiceAmountNet
          invoiceNumber
          invoiceDate
          invoiceLastSent
          invoiceReceivers
          servicePeriodStart
          servicePeriodEnd
          taxRate
          shippingCost
          shippingCostNet
          paymentCost
          discountCode
          discountAmount
          discountType
          paymentProvider
          stripeSessionId
          totalAmount
          createdAt
          updatedAt
          orderFinancialOrderId
          __typename
        }
        data
        totalAmount
        createdAt
        updatedAt
        industryOrdersId
        companyOrdersId
        userOrdersId
        eventOrdersId
        orderFinancialId
        owner
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getOrderFinancial = /* GraphQL */ `
  query GetOrderFinancial($id: ID!) {
    getOrderFinancial(id: $id) {
      id
      isBusiness
      isInterEUDelivery
      vatInfo {
        vatNumber
        country
        __typename
      }
      currency
      documents {
        documentType
        s3Path
        documentNumber
        referingDocumentNumber
        documentName
        status
        date
        amount
        amountNet
        sentToCustomerTime
        sentToCustomerAddresses
        lineItemIds
        __typename
      }
      invoiceAmount
      invoiceAmountNet
      invoiceNumber
      invoiceDate
      invoiceFile {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      invoiceLastSent
      invoiceReceivers
      servicePeriodStart
      servicePeriodEnd
      taxRate
      shippingCost
      shippingCostNet
      paymentCost
      order {
        id
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        type
        orderNumber
        buyerOrderNumber
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        paymentStatus
        deliveryStatus
        products {
          nextToken
          __typename
        }
        lineItems {
          nextToken
          __typename
        }
        notes
        deliveryAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        financial {
          id
          isBusiness
          isInterEUDelivery
          currency
          invoiceAmount
          invoiceAmountNet
          invoiceNumber
          invoiceDate
          invoiceLastSent
          invoiceReceivers
          servicePeriodStart
          servicePeriodEnd
          taxRate
          shippingCost
          shippingCostNet
          paymentCost
          discountCode
          discountAmount
          discountType
          paymentProvider
          stripeSessionId
          totalAmount
          createdAt
          updatedAt
          orderFinancialOrderId
          __typename
        }
        data
        totalAmount
        createdAt
        updatedAt
        industryOrdersId
        companyOrdersId
        userOrdersId
        eventOrdersId
        orderFinancialId
        owner
        __typename
      }
      payments {
        items {
          id
          status
          isPayed
          amount
          currency
          paymentProvider
          transactionId
          paymentDate
          paymentAmount
          paymentCurrency
          createdAt
          updatedAt
          orderFinancialPaymentsId
          __typename
        }
        nextToken
        __typename
      }
      discountCode
      discountAmount
      discountType
      paymentProvider
      stripeSessionId
      totalAmount
      createdAt
      updatedAt
      orderFinancialOrderId
      __typename
    }
  }
`;
export const listOrderFinancials = /* GraphQL */ `
  query ListOrderFinancials(
    $filter: ModelOrderFinancialFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderFinancials(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        isBusiness
        isInterEUDelivery
        vatInfo {
          vatNumber
          country
          __typename
        }
        currency
        documents {
          documentType
          s3Path
          documentNumber
          referingDocumentNumber
          documentName
          status
          date
          amount
          amountNet
          sentToCustomerTime
          sentToCustomerAddresses
          lineItemIds
          __typename
        }
        invoiceAmount
        invoiceAmountNet
        invoiceNumber
        invoiceDate
        invoiceFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        invoiceLastSent
        invoiceReceivers
        servicePeriodStart
        servicePeriodEnd
        taxRate
        shippingCost
        shippingCostNet
        paymentCost
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        payments {
          nextToken
          __typename
        }
        discountCode
        discountAmount
        discountType
        paymentProvider
        stripeSessionId
        totalAmount
        createdAt
        updatedAt
        orderFinancialOrderId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrderLineItem = /* GraphQL */ `
  query GetOrderLineItem($id: ID!) {
    getOrderLineItem(id: $id) {
      id
      order {
        id
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        type
        orderNumber
        buyerOrderNumber
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        paymentStatus
        deliveryStatus
        products {
          nextToken
          __typename
        }
        lineItems {
          nextToken
          __typename
        }
        notes
        deliveryAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        financial {
          id
          isBusiness
          isInterEUDelivery
          currency
          invoiceAmount
          invoiceAmountNet
          invoiceNumber
          invoiceDate
          invoiceLastSent
          invoiceReceivers
          servicePeriodStart
          servicePeriodEnd
          taxRate
          shippingCost
          shippingCostNet
          paymentCost
          discountCode
          discountAmount
          discountType
          paymentProvider
          stripeSessionId
          totalAmount
          createdAt
          updatedAt
          orderFinancialOrderId
          __typename
        }
        data
        totalAmount
        createdAt
        updatedAt
        industryOrdersId
        companyOrdersId
        userOrdersId
        eventOrdersId
        orderFinancialId
        owner
        __typename
      }
      parentLineItemId
      product {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      productID
      qty
      price
      downPaymentPrice
      discount
      discountType
      taxRate
      taxAmount
      bookedBooth {
        id
        type
        orderLineItem {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        boothNumber
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        equipment {
          nextToken
          __typename
        }
        customRequests {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyBookedBoothsId
        eventBookedBoothsId
        bookedBoothOrderLineItemId
        __typename
      }
      boothNumber
      boothArea
      priceDetails
      bookedBoothEquipment {
        id
        bookedBooth {
          id
          type
          boothNumber
          status
          createdAt
          updatedAt
          companyBookedBoothsId
          eventBookedBoothsId
          bookedBoothOrderLineItemId
          __typename
        }
        qty
        orderLineItem {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        status
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        data
        createdAt
        updatedAt
        bookedBoothEquipmentId
        boothEquipmentOrderLineItemId
        __typename
      }
      bookedTicket {
        owner
        id
        industryId
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        createdByUserId
        userTicketsId
        eventDays
        status
        paymentStatus
        type
        visitorType
        addons
        payment {
          id
          status
          isPayed
          amount
          currency
          paymentProvider
          transactionId
          paymentDate
          paymentAmount
          paymentCurrency
          createdAt
          updatedAt
          orderFinancialPaymentsId
          __typename
        }
        ticketFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        notes
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        invitationCode
        orderNumber
        firstName
        lastName
        companyName
        scans {
          nextToken
          __typename
        }
        personalAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        personalContact {
          phone
          mobile
          fax
          email
          __typename
        }
        isFreeTicket
        createdAt
        updatedAt
        ticketEventId
        ticketCompanyId
        ticketPaymentId
        __typename
      }
      isCanceled
      isDeletedBoothMainItem
      stockReturned
      boothEquipmentRemoved
      cancelationDate
      cancelationDocumentNumber
      createdAt
      updatedAt
      orderLineItemsId
      productOrderLineItemsId
      orderLineItemProductId
      orderLineItemBookedBoothId
      orderLineItemBookedBoothEquipmentId
      orderLineItemBookedTicketId
      __typename
    }
  }
`;
export const listOrderLineItems = /* GraphQL */ `
  query ListOrderLineItems(
    $filter: ModelOrderLineItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderLineItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        parentLineItemId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        productID
        qty
        price
        downPaymentPrice
        discount
        discountType
        taxRate
        taxAmount
        bookedBooth {
          id
          type
          boothNumber
          status
          createdAt
          updatedAt
          companyBookedBoothsId
          eventBookedBoothsId
          bookedBoothOrderLineItemId
          __typename
        }
        boothNumber
        boothArea
        priceDetails
        bookedBoothEquipment {
          id
          qty
          status
          data
          createdAt
          updatedAt
          bookedBoothEquipmentId
          boothEquipmentOrderLineItemId
          __typename
        }
        bookedTicket {
          owner
          id
          industryId
          createdByUserId
          userTicketsId
          eventDays
          status
          paymentStatus
          type
          visitorType
          addons
          notes
          billingEmail
          invitationCode
          orderNumber
          firstName
          lastName
          companyName
          isFreeTicket
          createdAt
          updatedAt
          ticketEventId
          ticketCompanyId
          ticketPaymentId
          __typename
        }
        isCanceled
        isDeletedBoothMainItem
        stockReturned
        boothEquipmentRemoved
        cancelationDate
        cancelationDocumentNumber
        createdAt
        updatedAt
        orderLineItemsId
        productOrderLineItemsId
        orderLineItemProductId
        orderLineItemBookedBoothId
        orderLineItemBookedBoothEquipmentId
        orderLineItemBookedTicketId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPayment = /* GraphQL */ `
  query GetPayment($id: ID!) {
    getPayment(id: $id) {
      id
      orderFinancial {
        id
        isBusiness
        isInterEUDelivery
        vatInfo {
          vatNumber
          country
          __typename
        }
        currency
        documents {
          documentType
          s3Path
          documentNumber
          referingDocumentNumber
          documentName
          status
          date
          amount
          amountNet
          sentToCustomerTime
          sentToCustomerAddresses
          lineItemIds
          __typename
        }
        invoiceAmount
        invoiceAmountNet
        invoiceNumber
        invoiceDate
        invoiceFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        invoiceLastSent
        invoiceReceivers
        servicePeriodStart
        servicePeriodEnd
        taxRate
        shippingCost
        shippingCostNet
        paymentCost
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        payments {
          nextToken
          __typename
        }
        discountCode
        discountAmount
        discountType
        paymentProvider
        stripeSessionId
        totalAmount
        createdAt
        updatedAt
        orderFinancialOrderId
        __typename
      }
      status
      isPayed
      amount
      currency
      paymentProvider
      transactionId
      paymentDate
      paymentAmount
      paymentCurrency
      createdAt
      updatedAt
      orderFinancialPaymentsId
      __typename
    }
  }
`;
export const listPayments = /* GraphQL */ `
  query ListPayments(
    $filter: ModelPaymentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderFinancial {
          id
          isBusiness
          isInterEUDelivery
          currency
          invoiceAmount
          invoiceAmountNet
          invoiceNumber
          invoiceDate
          invoiceLastSent
          invoiceReceivers
          servicePeriodStart
          servicePeriodEnd
          taxRate
          shippingCost
          shippingCostNet
          paymentCost
          discountCode
          discountAmount
          discountType
          paymentProvider
          stripeSessionId
          totalAmount
          createdAt
          updatedAt
          orderFinancialOrderId
          __typename
        }
        status
        isPayed
        amount
        currency
        paymentProvider
        transactionId
        paymentDate
        paymentAmount
        paymentCurrency
        createdAt
        updatedAt
        orderFinancialPaymentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBundleBooth = /* GraphQL */ `
  query GetBundleBooth($id: ID!) {
    getBundleBooth(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      sku
      boothNumber
      availableInEvents {
        items {
          id
          bundleBoothId
          eventId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      price
      images {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      features {
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        __typename
      }
      files {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      floorPlan {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      status
      availablePrints {
        items {
          id
          dimensions
          type
          createdAt
          updatedAt
          bundleBoothAvailablePrintsId
          __typename
        }
        nextToken
        __typename
      }
      avaiableFloors {
        items {
          id
          color
          createdAt
          updatedAt
          bundleBoothAvaiableFloorsId
          __typename
        }
        nextToken
        __typename
      }
      avaiableAccessories {
        items {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        nextToken
        __typename
      }
      includedMarketingPackage {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        images {
          __typename
        }
        features {
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      includedAccessories {
        items {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBundleBooths = /* GraphQL */ `
  query ListBundleBooths(
    $filter: ModelBundleBoothFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBundleBooths(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        sku
        boothNumber
        availableInEvents {
          nextToken
          __typename
        }
        price
        images {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        status
        availablePrints {
          nextToken
          __typename
        }
        avaiableFloors {
          nextToken
          __typename
        }
        avaiableAccessories {
          nextToken
          __typename
        }
        includedMarketingPackage {
          id
          createdAt
          updatedAt
          __typename
        }
        includedAccessories {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBookedBooth = /* GraphQL */ `
  query GetBookedBooth($id: ID!) {
    getBookedBooth(id: $id) {
      id
      type
      orderLineItem {
        id
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        parentLineItemId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        productID
        qty
        price
        downPaymentPrice
        discount
        discountType
        taxRate
        taxAmount
        bookedBooth {
          id
          type
          boothNumber
          status
          createdAt
          updatedAt
          companyBookedBoothsId
          eventBookedBoothsId
          bookedBoothOrderLineItemId
          __typename
        }
        boothNumber
        boothArea
        priceDetails
        bookedBoothEquipment {
          id
          qty
          status
          data
          createdAt
          updatedAt
          bookedBoothEquipmentId
          boothEquipmentOrderLineItemId
          __typename
        }
        bookedTicket {
          owner
          id
          industryId
          createdByUserId
          userTicketsId
          eventDays
          status
          paymentStatus
          type
          visitorType
          addons
          notes
          billingEmail
          invitationCode
          orderNumber
          firstName
          lastName
          companyName
          isFreeTicket
          createdAt
          updatedAt
          ticketEventId
          ticketCompanyId
          ticketPaymentId
          __typename
        }
        isCanceled
        isDeletedBoothMainItem
        stockReturned
        boothEquipmentRemoved
        cancelationDate
        cancelationDocumentNumber
        createdAt
        updatedAt
        orderLineItemsId
        productOrderLineItemsId
        orderLineItemProductId
        orderLineItemBookedBoothId
        orderLineItemBookedBoothEquipmentId
        orderLineItemBookedTicketId
        __typename
      }
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      boothNumber
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      status
      equipment {
        items {
          id
          qty
          status
          data
          createdAt
          updatedAt
          bookedBoothEquipmentId
          boothEquipmentOrderLineItemId
          __typename
        }
        nextToken
        __typename
      }
      customRequests {
        items {
          id
          owner
          requestText
          status
          createdByUserId
          adminNotes
          createdAt
          updatedAt
          bookedBoothCustomRequestsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyBookedBoothsId
      eventBookedBoothsId
      bookedBoothOrderLineItemId
      __typename
    }
  }
`;
export const listBookedBooths = /* GraphQL */ `
  query ListBookedBooths(
    $filter: ModelBookedBoothFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookedBooths(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        orderLineItem {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        boothNumber
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        equipment {
          nextToken
          __typename
        }
        customRequests {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyBookedBoothsId
        eventBookedBoothsId
        bookedBoothOrderLineItemId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchBookedBooths = /* GraphQL */ `
  query SearchBookedBooths(
    $filter: SearchableBookedBoothFilterInput
    $sort: [SearchableBookedBoothSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableBookedBoothAggregationInput]
  ) {
    searchBookedBooths(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        type
        orderLineItem {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        boothNumber
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        equipment {
          nextToken
          __typename
        }
        customRequests {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyBookedBoothsId
        eventBookedBoothsId
        bookedBoothOrderLineItemId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getBoothEquipment = /* GraphQL */ `
  query GetBoothEquipment($id: ID!) {
    getBoothEquipment(id: $id) {
      id
      bookedBooth {
        id
        type
        orderLineItem {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        boothNumber
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        equipment {
          nextToken
          __typename
        }
        customRequests {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyBookedBoothsId
        eventBookedBoothsId
        bookedBoothOrderLineItemId
        __typename
      }
      qty
      orderLineItem {
        id
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        parentLineItemId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        productID
        qty
        price
        downPaymentPrice
        discount
        discountType
        taxRate
        taxAmount
        bookedBooth {
          id
          type
          boothNumber
          status
          createdAt
          updatedAt
          companyBookedBoothsId
          eventBookedBoothsId
          bookedBoothOrderLineItemId
          __typename
        }
        boothNumber
        boothArea
        priceDetails
        bookedBoothEquipment {
          id
          qty
          status
          data
          createdAt
          updatedAt
          bookedBoothEquipmentId
          boothEquipmentOrderLineItemId
          __typename
        }
        bookedTicket {
          owner
          id
          industryId
          createdByUserId
          userTicketsId
          eventDays
          status
          paymentStatus
          type
          visitorType
          addons
          notes
          billingEmail
          invitationCode
          orderNumber
          firstName
          lastName
          companyName
          isFreeTicket
          createdAt
          updatedAt
          ticketEventId
          ticketCompanyId
          ticketPaymentId
          __typename
        }
        isCanceled
        isDeletedBoothMainItem
        stockReturned
        boothEquipmentRemoved
        cancelationDate
        cancelationDocumentNumber
        createdAt
        updatedAt
        orderLineItemsId
        productOrderLineItemsId
        orderLineItemProductId
        orderLineItemBookedBoothId
        orderLineItemBookedBoothEquipmentId
        orderLineItemBookedTicketId
        __typename
      }
      status
      files {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      data
      createdAt
      updatedAt
      bookedBoothEquipmentId
      boothEquipmentOrderLineItemId
      __typename
    }
  }
`;
export const listBoothEquipments = /* GraphQL */ `
  query ListBoothEquipments(
    $filter: ModelBoothEquipmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBoothEquipments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        bookedBooth {
          id
          type
          boothNumber
          status
          createdAt
          updatedAt
          companyBookedBoothsId
          eventBookedBoothsId
          bookedBoothOrderLineItemId
          __typename
        }
        qty
        orderLineItem {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        status
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        data
        createdAt
        updatedAt
        bookedBoothEquipmentId
        boothEquipmentOrderLineItemId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBoothCustomRequest = /* GraphQL */ `
  query GetBoothCustomRequest($id: ID!) {
    getBoothCustomRequest(id: $id) {
      id
      owner
      bookedBooth {
        id
        type
        orderLineItem {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        boothNumber
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        equipment {
          nextToken
          __typename
        }
        customRequests {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyBookedBoothsId
        eventBookedBoothsId
        bookedBoothOrderLineItemId
        __typename
      }
      requestText
      status
      createdByUserId
      adminNotes
      createdAt
      updatedAt
      bookedBoothCustomRequestsId
      __typename
    }
  }
`;
export const listBoothCustomRequests = /* GraphQL */ `
  query ListBoothCustomRequests(
    $filter: ModelBoothCustomRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBoothCustomRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        bookedBooth {
          id
          type
          boothNumber
          status
          createdAt
          updatedAt
          companyBookedBoothsId
          eventBookedBoothsId
          bookedBoothOrderLineItemId
          __typename
        }
        requestText
        status
        createdByUserId
        adminNotes
        createdAt
        updatedAt
        bookedBoothCustomRequestsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDiscountCode = /* GraphQL */ `
  query GetDiscountCode($id: ID!) {
    getDiscountCode(id: $id) {
      id
      code
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      discountType
      discountAmount
      discountPercentage
      maxUsage
      usageCount
      startDate
      endDate
      status
      restrictedProductIds
      canBeCombined
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listDiscountCodes = /* GraphQL */ `
  query ListDiscountCodes(
    $filter: ModelDiscountCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDiscountCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        code
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        discountType
        discountAmount
        discountPercentage
        maxUsage
        usageCount
        startDate
        endDate
        status
        restrictedProductIds
        canBeCombined
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const discountCodesByCode = /* GraphQL */ `
  query DiscountCodesByCode(
    $code: String!
    $sortDirection: ModelSortDirection
    $filter: ModelDiscountCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    discountCodesByCode(
      code: $code
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        discountType
        discountAmount
        discountPercentage
        maxUsage
        usageCount
        startDate
        endDate
        status
        restrictedProductIds
        canBeCombined
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBoothPlanArea = /* GraphQL */ `
  query GetBoothPlanArea($id: ID!) {
    getBoothPlanArea(id: $id) {
      id
      eventId
      boothNumber
      points
      labelX
      labelY
      source
      planVersionId
      labelSize
      areaUnits
      bbox
      variant
      size
      bookable
      positionType
      zone
      openSides
      attributes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBoothPlanAreas = /* GraphQL */ `
  query ListBoothPlanAreas(
    $filter: ModelBoothPlanAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBoothPlanAreas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventId
        boothNumber
        points
        labelX
        labelY
        source
        planVersionId
        labelSize
        areaUnits
        bbox
        variant
        size
        bookable
        positionType
        zone
        openSides
        attributes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const boothPlanAreasByEvent = /* GraphQL */ `
  query BoothPlanAreasByEvent(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBoothPlanAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    boothPlanAreasByEvent(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        boothNumber
        points
        labelX
        labelY
        source
        planVersionId
        labelSize
        areaUnits
        bbox
        variant
        size
        bookable
        positionType
        zone
        openSides
        attributes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const boothPlanAreasByPlanVersion = /* GraphQL */ `
  query BoothPlanAreasByPlanVersion(
    $planVersionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBoothPlanAreaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    boothPlanAreasByPlanVersion(
      planVersionId: $planVersionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        boothNumber
        points
        labelX
        labelY
        source
        planVersionId
        labelSize
        areaUnits
        bbox
        variant
        size
        bookable
        positionType
        zone
        openSides
        attributes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getHallPlanVersion = /* GraphQL */ `
  query GetHallPlanVersion($id: ID!) {
    getHallPlanVersion(id: $id) {
      id
      eventId
      status
      fileName
      viewBox
      width
      height
      sourceFile {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      backgroundFile {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      summary
      issues
      matchSummary
      standsCount
      errorCount
      warningCount
      unitsPerMeter
      uploadedBy
      activatedAt
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listHallPlanVersions = /* GraphQL */ `
  query ListHallPlanVersions(
    $filter: ModelHallPlanVersionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listHallPlanVersions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        status
        fileName
        viewBox
        width
        height
        sourceFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        backgroundFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        summary
        issues
        matchSummary
        standsCount
        errorCount
        warningCount
        unitsPerMeter
        uploadedBy
        activatedAt
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const hallPlanVersionsByEvent = /* GraphQL */ `
  query HallPlanVersionsByEvent(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelHallPlanVersionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    hallPlanVersionsByEvent(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        status
        fileName
        viewBox
        width
        height
        sourceFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        backgroundFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        summary
        issues
        matchSummary
        standsCount
        errorCount
        warningCount
        unitsPerMeter
        uploadedBy
        activatedAt
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBoothWaitlistEntry = /* GraphQL */ `
  query GetBoothWaitlistEntry($id: ID!) {
    getBoothWaitlistEntry(id: $id) {
      id
      eventId
      eventProductId
      boothNumber
      companyId
      userId
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBoothWaitlistEntries = /* GraphQL */ `
  query ListBoothWaitlistEntries(
    $filter: ModelBoothWaitlistEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBoothWaitlistEntries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        eventProductId
        boothNumber
        companyId
        userId
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const boothWaitlistEntriesByEvent = /* GraphQL */ `
  query BoothWaitlistEntriesByEvent(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBoothWaitlistEntryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    boothWaitlistEntriesByEvent(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        eventProductId
        boothNumber
        companyId
        userId
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTopic = /* GraphQL */ `
  query GetTopic($id: ID!) {
    getTopic(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      color
      topicGroup {
        id
        industryId
        name {
          language
          text
          __typename
        }
        color
        topics {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        __typename
      }
      companies {
        items {
          id
          topicId
          companyId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      lectures {
        items {
          id
          topicId
          lectureId
          createdAt
          updatedAt
          usersCanEdit
          __typename
        }
        nextToken
        __typename
      }
      sortKey
      createdAt
      updatedAt
      topicGroupTopicsId
      __typename
    }
  }
`;
export const listTopics = /* GraphQL */ `
  query ListTopics(
    $filter: ModelTopicFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTopics(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        color
        topicGroup {
          id
          industryId
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        companies {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        topicGroupTopicsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchTopics = /* GraphQL */ `
  query SearchTopics(
    $filter: SearchableTopicFilterInput
    $sort: [SearchableTopicSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableTopicAggregationInput]
  ) {
    searchTopics(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name {
          language
          text
          __typename
        }
        color
        topicGroup {
          id
          industryId
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        companies {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        topicGroupTopicsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getTopicGroup = /* GraphQL */ `
  query GetTopicGroup($id: ID!) {
    getTopicGroup(id: $id) {
      id
      industryId
      name {
        language
        text
        __typename
      }
      color
      topics {
        items {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        nextToken
        __typename
      }
      sortKey
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTopicGroups = /* GraphQL */ `
  query ListTopicGroups(
    $filter: ModelTopicGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTopicGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        industryId
        name {
          language
          text
          __typename
        }
        color
        topics {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCMSInterests = /* GraphQL */ `
  query GetCMSInterests($id: ID!) {
    getCMSInterests(id: $id) {
      name {
        language
        text
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCMSInterests = /* GraphQL */ `
  query ListCMSInterests(
    $filter: ModelCMSInterestsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCMSInterests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        name {
          language
          text
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCMSNews = /* GraphQL */ `
  query GetCMSNews($id: ID!) {
    getCMSNews(id: $id) {
      id
      industries {
        items {
          id
          cMSNewsId
          industryId
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      type
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      employee {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      topic {
        id
        name {
          language
          text
          __typename
        }
        color
        topicGroup {
          id
          industryId
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        companies {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        topicGroupTopicsId
        __typename
      }
      name {
        language
        text
        __typename
      }
      slug
      slugHistory
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      interests {
        name {
          language
          text
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      content {
        language
        text
        __typename
      }
      file {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      file3DModel {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      conditions {
        name
        accepted
        __typename
      }
      adminComment
      approved
      status
      isHero
      isHero2
      industryCMSItemIds {
        cms
        industryId
        itemId
        itemIds
        __typename
      }
      createdAt
      updatedAt
      companyNewsId
      employeeNewsId
      cMSNewsEmployeeId
      cMSNewsTopicId
      owner
      __typename
    }
  }
`;
export const listCMSNews = /* GraphQL */ `
  query ListCMSNews(
    $filter: ModelCMSNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCMSNews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        industries {
          nextToken
          __typename
        }
        type
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        interests {
          id
          createdAt
          updatedAt
          __typename
        }
        content {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        file3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        isHero
        isHero2
        industryCMSItemIds {
          cms
          industryId
          itemId
          itemIds
          __typename
        }
        createdAt
        updatedAt
        companyNewsId
        employeeNewsId
        cMSNewsEmployeeId
        cMSNewsTopicId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cmsNewsBySlug = /* GraphQL */ `
  query CmsNewsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCMSNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cmsNewsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        industries {
          nextToken
          __typename
        }
        type
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        interests {
          id
          createdAt
          updatedAt
          __typename
        }
        content {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        file3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        isHero
        isHero2
        industryCMSItemIds {
          cms
          industryId
          itemId
          itemIds
          __typename
        }
        createdAt
        updatedAt
        companyNewsId
        employeeNewsId
        cMSNewsEmployeeId
        cMSNewsTopicId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCMSNews = /* GraphQL */ `
  query SearchCMSNews(
    $filter: SearchableCMSNewsFilterInput
    $sort: [SearchableCMSNewsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCMSNewsAggregationInput]
  ) {
    searchCMSNews(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        industries {
          nextToken
          __typename
        }
        type
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        interests {
          id
          createdAt
          updatedAt
          __typename
        }
        content {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        file3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        isHero
        isHero2
        industryCMSItemIds {
          cms
          industryId
          itemId
          itemIds
          __typename
        }
        createdAt
        updatedAt
        companyNewsId
        employeeNewsId
        cMSNewsEmployeeId
        cMSNewsTopicId
        owner
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getNewsTicketNews = /* GraphQL */ `
  query GetNewsTicketNews($id: ID!) {
    getNewsTicketNews(id: $id) {
      id
      title {
        language
        text
        __typename
      }
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      link
      excerpt {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      externalNewsId
      WPJetEngineId
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listNewsTicketNews = /* GraphQL */ `
  query ListNewsTicketNews(
    $filter: ModelNewsTicketNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNewsTicketNews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title {
          language
          text
          __typename
        }
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        link
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        externalNewsId
        WPJetEngineId
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const newsTicketNewsByExternalNewsId = /* GraphQL */ `
  query NewsTicketNewsByExternalNewsId(
    $externalNewsId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelNewsTicketNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    newsTicketNewsByExternalNewsId(
      externalNewsId: $externalNewsId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title {
          language
          text
          __typename
        }
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        link
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        externalNewsId
        WPJetEngineId
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchNewsTicketNews = /* GraphQL */ `
  query SearchNewsTicketNews(
    $filter: SearchableNewsTicketNewsFilterInput
    $sort: [SearchableNewsTicketNewsSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableNewsTicketNewsAggregationInput]
  ) {
    searchNewsTicketNews(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        title {
          language
          text
          __typename
        }
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        link
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        externalNewsId
        WPJetEngineId
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getLecture = /* GraphQL */ `
  query GetLecture($id: ID!) {
    getLecture(id: $id) {
      id
      usersCanEdit
      industry {
        id
        name {
          language
          text
          __typename
        }
        subTitle {
          language
          text
          __typename
        }
        handle
        domain
        notificationEmailAddress
        primaryColor
        secondaryColor
        logo {
          fileName
          alt
          x4UUID
          __typename
        }
        favicon {
          fileName
          alt
          x4UUID
          __typename
        }
        sortKey
        status
        socialLinks {
          facebook
          x
          instagram
          spotify
          linkedin
          xing
          youtube
          pinterest
          snapchat
          tiktok
          __typename
        }
        events {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        orders {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        jetEngineAccess {
          baseurl
          username
          password
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      type
      startTime
      endTime
      dateTimes
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      seminar {
        id
        name {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        cover {
          fileName
          alt
          x4UUID
          __typename
        }
        seminarDays {
          date
          startTime
          endTime
          __typename
        }
        location {
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        speakers {
          nextToken
          __typename
        }
        CTABulletPoints {
          __typename
        }
        bookingStartDate
        bookingEndDate
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        academyTopics {
          nextToken
          __typename
        }
        status
        sortKey
        WPJetEngineId
        createdAt
        updatedAt
        seminarProductId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      companyBooth
      speakers {
        items {
          id
          lectureId
          employeeId
          createdAt
          updatedAt
          usersCanEdit
          userCognitoId
          __typename
        }
        nextToken
        __typename
      }
      speakersUsers {
        items {
          id
          lectureId
          userId
          createdAt
          updatedAt
          usersCanEdit
          owner
          __typename
        }
        nextToken
        __typename
      }
      session
      mainSpeaker {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      mainSpeakerUser {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      room
      title {
        language
        text
        __typename
      }
      slug
      slugHistory
      subjects {
        id
        name {
          language
          text
          __typename
        }
        __typename
      }
      speakerAffiliations {
        speakerId
        source
        companyId
        companyName
        __typename
      }
      topics {
        items {
          id
          topicId
          lectureId
          createdAt
          updatedAt
          usersCanEdit
          __typename
        }
        nextToken
        __typename
      }
      content {
        language
        text
        __typename
      }
      conditions {
        name
        accepted
        __typename
      }
      presentationLanguage
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      pdfDe {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      pdfEn {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      videoS3Key {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      presentation {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      adminComment
      adminTopic {
        id
        name {
          language
          text
          __typename
        }
        color
        topicGroup {
          id
          industryId
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        companies {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        topicGroupTopicsId
        __typename
      }
      approved
      approvedInsight
      lengthInSeconds
      status
      videoProgress {
        items {
          id
          userId
          videoId
          progressInSeconds
          totalWatchedInSeconds
          createdAt
          updatedAt
          lectureVideoProgressId
          userVideoProgressId
          __typename
        }
        nextToken
        __typename
      }
      courses {
        items {
          id
          courseId
          lectureId
          createdAt
          updatedAt
          usersCanEdit
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      seminarLecturesId
      industryLecturesId
      companyLecturesId
      eventLecturesId
      lectureMainSpeakerId
      lectureMainSpeakerUserId
      lectureAdminTopicId
      __typename
    }
  }
`;
export const listLectures = /* GraphQL */ `
  query ListLectures(
    $filter: ModelLectureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLectures(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        usersCanEdit
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        companyBooth
        speakers {
          nextToken
          __typename
        }
        speakersUsers {
          nextToken
          __typename
        }
        session
        mainSpeaker {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        mainSpeakerUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        room
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        subjects {
          id
          __typename
        }
        speakerAffiliations {
          speakerId
          source
          companyId
          companyName
          __typename
        }
        topics {
          nextToken
          __typename
        }
        content {
          language
          text
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        presentationLanguage
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        pdfDe {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        pdfEn {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        videoS3Key {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        presentation {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        adminComment
        adminTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        approved
        approvedInsight
        lengthInSeconds
        status
        videoProgress {
          nextToken
          __typename
        }
        courses {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarLecturesId
        industryLecturesId
        companyLecturesId
        eventLecturesId
        lectureMainSpeakerId
        lectureMainSpeakerUserId
        lectureAdminTopicId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesBySlug = /* GraphQL */ `
  query LecturesBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelLectureFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        usersCanEdit
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        companyBooth
        speakers {
          nextToken
          __typename
        }
        speakersUsers {
          nextToken
          __typename
        }
        session
        mainSpeaker {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        mainSpeakerUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        room
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        subjects {
          id
          __typename
        }
        speakerAffiliations {
          speakerId
          source
          companyId
          companyName
          __typename
        }
        topics {
          nextToken
          __typename
        }
        content {
          language
          text
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        presentationLanguage
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        pdfDe {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        pdfEn {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        videoS3Key {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        presentation {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        adminComment
        adminTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        approved
        approvedInsight
        lengthInSeconds
        status
        videoProgress {
          nextToken
          __typename
        }
        courses {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarLecturesId
        industryLecturesId
        companyLecturesId
        eventLecturesId
        lectureMainSpeakerId
        lectureMainSpeakerUserId
        lectureAdminTopicId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchLectures = /* GraphQL */ `
  query SearchLectures(
    $filter: SearchableLectureFilterInput
    $sort: [SearchableLectureSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableLectureAggregationInput]
  ) {
    searchLectures(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        usersCanEdit
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        companyBooth
        speakers {
          nextToken
          __typename
        }
        speakersUsers {
          nextToken
          __typename
        }
        session
        mainSpeaker {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        mainSpeakerUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        room
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        subjects {
          id
          __typename
        }
        speakerAffiliations {
          speakerId
          source
          companyId
          companyName
          __typename
        }
        topics {
          nextToken
          __typename
        }
        content {
          language
          text
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        presentationLanguage
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        pdfDe {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        pdfEn {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        videoS3Key {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        presentation {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        adminComment
        adminTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        approved
        approvedInsight
        lengthInSeconds
        status
        videoProgress {
          nextToken
          __typename
        }
        courses {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarLecturesId
        industryLecturesId
        companyLecturesId
        eventLecturesId
        lectureMainSpeakerId
        lectureMainSpeakerUserId
        lectureAdminTopicId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCMSProduct = /* GraphQL */ `
  query GetCMSProduct($id: ID!) {
    getCMSProduct(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      slug
      slugHistory
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      employee {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      images {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      previewImage {
        fileName
        alt
        x4UUID
        __typename
      }
      content {
        language
        text
        __typename
      }
      excerpt {
        language
        text
        __typename
      }
      file {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      file3DModel {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      interests {
        name {
          language
          text
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      type
      topic {
        id
        name {
          language
          text
          __typename
        }
        color
        topicGroup {
          id
          industryId
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        companies {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        topicGroupTopicsId
        __typename
      }
      conditions {
        name
        accepted
        __typename
      }
      adminComment
      approved
      status
      createdAt
      updatedAt
      companyProductsId
      cMSProductEmployeeId
      cMSProductTopicId
      owner
      __typename
    }
  }
`;
export const listCMSProducts = /* GraphQL */ `
  query ListCMSProducts(
    $filter: ModelCMSProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCMSProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        images {
          __typename
        }
        previewImage {
          fileName
          alt
          x4UUID
          __typename
        }
        content {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        file3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        interests {
          id
          createdAt
          updatedAt
          __typename
        }
        type
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        createdAt
        updatedAt
        companyProductsId
        cMSProductEmployeeId
        cMSProductTopicId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cmsProductsBySlug = /* GraphQL */ `
  query CmsProductsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCMSProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cmsProductsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        images {
          __typename
        }
        previewImage {
          fileName
          alt
          x4UUID
          __typename
        }
        content {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        file3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        interests {
          id
          createdAt
          updatedAt
          __typename
        }
        type
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        createdAt
        updatedAt
        companyProductsId
        cMSProductEmployeeId
        cMSProductTopicId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCMSProducts = /* GraphQL */ `
  query SearchCMSProducts(
    $filter: SearchableCMSProductFilterInput
    $sort: [SearchableCMSProductSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCMSProductAggregationInput]
  ) {
    searchCMSProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        images {
          __typename
        }
        previewImage {
          fileName
          alt
          x4UUID
          __typename
        }
        content {
          language
          text
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        file3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        interests {
          id
          createdAt
          updatedAt
          __typename
        }
        type
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        createdAt
        updatedAt
        companyProductsId
        cMSProductEmployeeId
        cMSProductTopicId
        owner
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCMSJobListing = /* GraphQL */ `
  query GetCMSJobListing($id: ID!) {
    getCMSJobListing(id: $id) {
      id
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      employee {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      name {
        language
        text
        __typename
      }
      slug
      slugHistory
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      previewImage {
        fileName
        alt
        x4UUID
        __typename
      }
      content {
        language
        text
        __typename
      }
      file {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      conditions {
        name
        accepted
        __typename
      }
      adminComment
      approved
      status
      createdAt
      updatedAt
      companyJobsId
      cMSJobListingEmployeeId
      owner
      __typename
    }
  }
`;
export const listCMSJobListings = /* GraphQL */ `
  query ListCMSJobListings(
    $filter: ModelCMSJobListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCMSJobListings(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        previewImage {
          fileName
          alt
          x4UUID
          __typename
        }
        content {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        createdAt
        updatedAt
        companyJobsId
        cMSJobListingEmployeeId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cmsJobListingsBySlug = /* GraphQL */ `
  query CmsJobListingsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCMSJobListingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cmsJobListingsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        previewImage {
          fileName
          alt
          x4UUID
          __typename
        }
        content {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        createdAt
        updatedAt
        companyJobsId
        cMSJobListingEmployeeId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCMSJobListings = /* GraphQL */ `
  query SearchCMSJobListings(
    $filter: SearchableCMSJobListingFilterInput
    $sort: [SearchableCMSJobListingSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCMSJobListingAggregationInput]
  ) {
    searchCMSJobListings(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        previewImage {
          fileName
          alt
          x4UUID
          __typename
        }
        content {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        createdAt
        updatedAt
        companyJobsId
        cMSJobListingEmployeeId
        owner
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getCMSTour = /* GraphQL */ `
  query GetCMSTour($id: ID!) {
    getCMSTour(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      fromDate
      toDate
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      tourCompanyRegistrations {
        items {
          id
          date
          status
          createdAt
          updatedAt
          cMSTourTourCompanyRegistrationsId
          companyTourRegistrationsId
          employeeTourRegistrationsId
          cMSTourCompanyRegistrationCompanyId
          cMSTourCompanyRegistrationEmployeeId
          owner
          __typename
        }
        nextToken
        __typename
      }
      tourVisitorRegistrations {
        items {
          id
          date
          status
          createdAt
          updatedAt
          cMSTourTourVisitorRegistrationsId
          companyTourVisitorRegistrationsId
          userTourRegistrationsId
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      eventToursId
      owner
      __typename
    }
  }
`;
export const listCMSTours = /* GraphQL */ `
  query ListCMSTours(
    $filter: ModelCMSTourFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCMSTours(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        fromDate
        toDate
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        tourCompanyRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        eventToursId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCMSTourCompanyRegistration = /* GraphQL */ `
  query GetCMSTourCompanyRegistration($id: ID!) {
    getCMSTourCompanyRegistration(id: $id) {
      id
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      employee {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      date
      tour {
        id
        name {
          language
          text
          __typename
        }
        fromDate
        toDate
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        tourCompanyRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        eventToursId
        owner
        __typename
      }
      status
      createdAt
      updatedAt
      cMSTourTourCompanyRegistrationsId
      companyTourRegistrationsId
      employeeTourRegistrationsId
      cMSTourCompanyRegistrationCompanyId
      cMSTourCompanyRegistrationEmployeeId
      owner
      __typename
    }
  }
`;
export const listCMSTourCompanyRegistrations = /* GraphQL */ `
  query ListCMSTourCompanyRegistrations(
    $filter: ModelCMSTourCompanyRegistrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCMSTourCompanyRegistrations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        date
        tour {
          id
          fromDate
          toDate
          createdAt
          updatedAt
          eventToursId
          owner
          __typename
        }
        status
        createdAt
        updatedAt
        cMSTourTourCompanyRegistrationsId
        companyTourRegistrationsId
        employeeTourRegistrationsId
        cMSTourCompanyRegistrationCompanyId
        cMSTourCompanyRegistrationEmployeeId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCMSTourVisitorRegistration = /* GraphQL */ `
  query GetCMSTourVisitorRegistration($id: ID!) {
    getCMSTourVisitorRegistration(id: $id) {
      id
      user {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      date
      tour {
        id
        name {
          language
          text
          __typename
        }
        fromDate
        toDate
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        tourCompanyRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        eventToursId
        owner
        __typename
      }
      status
      createdAt
      updatedAt
      cMSTourTourVisitorRegistrationsId
      companyTourVisitorRegistrationsId
      userTourRegistrationsId
      owner
      __typename
    }
  }
`;
export const listCMSTourVisitorRegistrations = /* GraphQL */ `
  query ListCMSTourVisitorRegistrations(
    $filter: ModelCMSTourVisitorRegistrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCMSTourVisitorRegistrations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        date
        tour {
          id
          fromDate
          toDate
          createdAt
          updatedAt
          eventToursId
          owner
          __typename
        }
        status
        createdAt
        updatedAt
        cMSTourTourVisitorRegistrationsId
        companyTourVisitorRegistrationsId
        userTourRegistrationsId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVideoProgress = /* GraphQL */ `
  query GetVideoProgress($id: ID!) {
    getVideoProgress(id: $id) {
      id
      userId
      user {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      videoId
      lecture {
        id
        usersCanEdit
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        companyBooth
        speakers {
          nextToken
          __typename
        }
        speakersUsers {
          nextToken
          __typename
        }
        session
        mainSpeaker {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        mainSpeakerUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        room
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        subjects {
          id
          __typename
        }
        speakerAffiliations {
          speakerId
          source
          companyId
          companyName
          __typename
        }
        topics {
          nextToken
          __typename
        }
        content {
          language
          text
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        presentationLanguage
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        pdfDe {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        pdfEn {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        videoS3Key {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        presentation {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        adminComment
        adminTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        approved
        approvedInsight
        lengthInSeconds
        status
        videoProgress {
          nextToken
          __typename
        }
        courses {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarLecturesId
        industryLecturesId
        companyLecturesId
        eventLecturesId
        lectureMainSpeakerId
        lectureMainSpeakerUserId
        lectureAdminTopicId
        __typename
      }
      progressInSeconds
      totalWatchedInSeconds
      createdAt
      updatedAt
      lectureVideoProgressId
      userVideoProgressId
      __typename
    }
  }
`;
export const listVideoProgresses = /* GraphQL */ `
  query ListVideoProgresses(
    $filter: ModelVideoProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVideoProgresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userId
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        videoId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        progressInSeconds
        totalWatchedInSeconds
        createdAt
        updatedAt
        lectureVideoProgressId
        userVideoProgressId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const videoProgressByUser = /* GraphQL */ `
  query VideoProgressByUser(
    $userId: String!
    $sortDirection: ModelSortDirection
    $filter: ModelVideoProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    videoProgressByUser(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        videoId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        progressInSeconds
        totalWatchedInSeconds
        createdAt
        updatedAt
        lectureVideoProgressId
        userVideoProgressId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const videoProgressByVideoAndUser = /* GraphQL */ `
  query VideoProgressByVideoAndUser(
    $videoId: String!
    $userId: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelVideoProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    videoProgressByVideoAndUser(
      videoId: $videoId
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        videoId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        progressInSeconds
        totalWatchedInSeconds
        createdAt
        updatedAt
        lectureVideoProgressId
        userVideoProgressId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCountry = /* GraphQL */ `
  query GetCountry($id: ID!) {
    getCountry(id: $id) {
      name {
        language
        text
        __typename
      }
      id
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCountries = /* GraphQL */ `
  query ListCountries(
    $filter: ModelCountryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCountries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        name {
          language
          text
          __typename
        }
        id
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMediaSeries = /* GraphQL */ `
  query GetMediaSeries($id: ID!) {
    getMediaSeries(id: $id) {
      id
      type
      title {
        language
        text
        __typename
      }
      slug
      slugHistory
      excerpt {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      host
      coverImage {
        fileName
        alt
        x4UUID
        __typename
      }
      status
      sortKey
      industryId
      legacyKey
      legacyData
      items {
        items {
          id
          mediaSeriesId
          slug
          slugHistory
          episodeNumber
          topic
          publishedAt
          isHero
          status
          sortKey
          guest
          guestEmail
          guestPhone
          host
          speaker
          companyName
          companyUrl
          companyId
          externalVideoUrl
          spotifyUrl
          podigeeUrl
          legacyKey
          legacyData
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMediaSeries = /* GraphQL */ `
  query ListMediaSeries(
    $filter: ModelMediaSeriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMediaSeries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        excerpt {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        host
        coverImage {
          fileName
          alt
          x4UUID
          __typename
        }
        status
        sortKey
        industryId
        legacyKey
        legacyData
        items {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediaSeriesBySlug = /* GraphQL */ `
  query MediaSeriesBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMediaSeriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediaSeriesBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        excerpt {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        host
        coverImage {
          fileName
          alt
          x4UUID
          __typename
        }
        status
        sortKey
        industryId
        legacyKey
        legacyData
        items {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMediaItem = /* GraphQL */ `
  query GetMediaItem($id: ID!) {
    getMediaItem(id: $id) {
      id
      mediaSeriesId
      series {
        id
        type
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        excerpt {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        host
        coverImage {
          fileName
          alt
          x4UUID
          __typename
        }
        status
        sortKey
        industryId
        legacyKey
        legacyData
        items {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      title {
        language
        text
        __typename
      }
      slug
      slugHistory
      excerpt {
        language
        text
        __typename
      }
      content {
        language
        text
        __typename
      }
      episodeNumber
      topic
      publishedAt
      isHero
      status
      sortKey
      guest
      guestEmail
      guestPhone
      host
      speaker
      companyName
      companyUrl
      companyId
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      audio {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      video {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      externalVideoUrl
      spotifyUrl
      podigeeUrl
      legacyKey
      legacyData
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMediaItems = /* GraphQL */ `
  query ListMediaItems(
    $filter: ModelMediaItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMediaItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        mediaSeriesId
        series {
          id
          type
          slug
          slugHistory
          host
          status
          sortKey
          industryId
          legacyKey
          legacyData
          createdAt
          updatedAt
          __typename
        }
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        episodeNumber
        topic
        publishedAt
        isHero
        status
        sortKey
        guest
        guestEmail
        guestPhone
        host
        speaker
        companyName
        companyUrl
        companyId
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        audio {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        video {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        externalVideoUrl
        spotifyUrl
        podigeeUrl
        legacyKey
        legacyData
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediaItemsByMediaSeries = /* GraphQL */ `
  query MediaItemsByMediaSeries(
    $mediaSeriesId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelMediaItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediaItemsByMediaSeries(
      mediaSeriesId: $mediaSeriesId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mediaSeriesId
        series {
          id
          type
          slug
          slugHistory
          host
          status
          sortKey
          industryId
          legacyKey
          legacyData
          createdAt
          updatedAt
          __typename
        }
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        episodeNumber
        topic
        publishedAt
        isHero
        status
        sortKey
        guest
        guestEmail
        guestPhone
        host
        speaker
        companyName
        companyUrl
        companyId
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        audio {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        video {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        externalVideoUrl
        spotifyUrl
        podigeeUrl
        legacyKey
        legacyData
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mediaItemsBySlug = /* GraphQL */ `
  query MediaItemsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelMediaItemFilterInput
    $limit: Int
    $nextToken: String
  ) {
    mediaItemsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        mediaSeriesId
        series {
          id
          type
          slug
          slugHistory
          host
          status
          sortKey
          industryId
          legacyKey
          legacyData
          createdAt
          updatedAt
          __typename
        }
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        excerpt {
          language
          text
          __typename
        }
        content {
          language
          text
          __typename
        }
        episodeNumber
        topic
        publishedAt
        isHero
        status
        sortKey
        guest
        guestEmail
        guestPhone
        host
        speaker
        companyName
        companyUrl
        companyId
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        audio {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        video {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        externalVideoUrl
        spotifyUrl
        podigeeUrl
        legacyKey
        legacyData
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      visibleInShop
      name {
        language
        text
        __typename
      }
      name_text
      category {
        id
        name {
          language
          text
          __typename
        }
        customerTypes
        description {
          language
          text
          __typename
        }
        sortKey
        image {
          __typename
        }
        products {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      invoiceName {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      shortDescription {
        language
        text
        __typename
      }
      includes {
        language
        text
        __typename
      }
      sku
      ean
      type
      subType
      price
      downPaymentPrice
      image {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      features {
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        __typename
      }
      files {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      orders {
        items {
          id
          orderId
          productId
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      orderLineItems {
        items {
          id
          parentLineItemId
          productID
          qty
          price
          downPaymentPrice
          discount
          discountType
          taxRate
          taxAmount
          boothNumber
          boothArea
          priceDetails
          isCanceled
          isDeletedBoothMainItem
          stockReturned
          boothEquipmentRemoved
          cancelationDate
          cancelationDocumentNumber
          createdAt
          updatedAt
          orderLineItemsId
          productOrderLineItemsId
          orderLineItemProductId
          orderLineItemBookedBoothId
          orderLineItemBookedBoothEquipmentId
          orderLineItemBookedTicketId
          __typename
        }
        nextToken
        __typename
      }
      allowedBuyerGroups
      requiredShipping
      icon
      stock
      stockReservations {
        items {
          id
          qty
          status
          reservationDate
          reservationEndDate
          boothNumber
          orderId
          eventId
          createdAt
          updatedAt
          productStockReservationsId
          eventProductStockReservationsId
          companyStockReservationsId
          __typename
        }
        nextToken
        __typename
      }
      availableInIndustries {
        items {
          id
          productId
          industryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availableInEvents {
        items {
          id
          productId
          eventId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      eventProducts {
        items {
          id
          price
          stock
          isAvailable
          sortKey
          boothPriceRule
          createdAt
          updatedAt
          productEventProductsId
          eventEventProductsId
          __typename
        }
        nextToken
        __typename
      }
      components {
        items {
          id
          parentProductID
          componentProductID
          qty
          order
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      boothNumber
      boothVariant
      boothVariantAliases
      boothMatchRule
      boothPriceMode
      boothPriceRule
      boothArea
      boothWidth
      boothDepth
      boothHeight
      boothDimensionFile {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      booth3DModel {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      bundleBoothAvaiableAccessoriesId
      bundleBoothIncludedAccessoriesId
      productCategoryProductsId
      __typename
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productsBySku = /* GraphQL */ `
  query ProductsBySku(
    $sku: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsBySku(
      sku: $sku
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productsByType = /* GraphQL */ `
  query ProductsByType(
    $type: String!
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByType(
      type: $type
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: [SearchableProductSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableProductAggregationInput]
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getProductCategory = /* GraphQL */ `
  query GetProductCategory($id: ID!) {
    getProductCategory(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      customerTypes
      description {
        language
        text
        __typename
      }
      sortKey
      image {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      products {
        items {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductCategories = /* GraphQL */ `
  query ListProductCategories(
    $filter: ModelProductCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name {
          language
          text
          __typename
        }
        customerTypes
        description {
          language
          text
          __typename
        }
        sortKey
        image {
          __typename
        }
        products {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getProductComponent = /* GraphQL */ `
  query GetProductComponent($id: ID!) {
    getProductComponent(id: $id) {
      id
      parentProductID
      parentProduct {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      componentProductID
      componentProduct {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      qty
      order
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listProductComponents = /* GraphQL */ `
  query ListProductComponents(
    $filter: ModelProductComponentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductComponents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentProductID
        parentProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        componentProductID
        componentProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        qty
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productComponentsByParentProductID = /* GraphQL */ `
  query ProductComponentsByParentProductID(
    $parentProductID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductComponentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productComponentsByParentProductID(
      parentProductID: $parentProductID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentProductID
        parentProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        componentProductID
        componentProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        qty
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const productComponentsByComponentProductID = /* GraphQL */ `
  query ProductComponentsByComponentProductID(
    $componentProductID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelProductComponentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productComponentsByComponentProductID(
      componentProductID: $componentProductID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentProductID
        parentProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        componentProductID
        componentProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        qty
        order
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEventProduct = /* GraphQL */ `
  query GetEventProduct($id: ID!) {
    getEventProduct(id: $id) {
      id
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      product {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      stockReservations {
        items {
          id
          qty
          status
          reservationDate
          reservationEndDate
          boothNumber
          orderId
          eventId
          createdAt
          updatedAt
          productStockReservationsId
          eventProductStockReservationsId
          companyStockReservationsId
          __typename
        }
        nextToken
        __typename
      }
      price
      timeRangePrices {
        timeRange {
          start
          end
          __typename
        }
        price
        __typename
      }
      stock
      isAvailable
      sortKey
      boothPriceRule
      createdAt
      updatedAt
      productEventProductsId
      eventEventProductsId
      __typename
    }
  }
`;
export const listEventProducts = /* GraphQL */ `
  query ListEventProducts(
    $filter: ModelEventProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        price
        timeRangePrices {
          price
          __typename
        }
        stock
        isAvailable
        sortKey
        boothPriceRule
        createdAt
        updatedAt
        productEventProductsId
        eventEventProductsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStockReservation = /* GraphQL */ `
  query GetStockReservation($id: ID!) {
    getStockReservation(id: $id) {
      id
      product {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      eventProduct {
        id
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        price
        timeRangePrices {
          price
          __typename
        }
        stock
        isAvailable
        sortKey
        boothPriceRule
        createdAt
        updatedAt
        productEventProductsId
        eventEventProductsId
        __typename
      }
      qty
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      status
      reservationDate
      reservationEndDate
      boothNumber
      orderId
      eventId
      createdAt
      updatedAt
      productStockReservationsId
      eventProductStockReservationsId
      companyStockReservationsId
      __typename
    }
  }
`;
export const listStockReservations = /* GraphQL */ `
  query ListStockReservations(
    $filter: ModelStockReservationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStockReservations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProduct {
          id
          price
          stock
          isAvailable
          sortKey
          boothPriceRule
          createdAt
          updatedAt
          productEventProductsId
          eventEventProductsId
          __typename
        }
        qty
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        reservationDate
        reservationEndDate
        boothNumber
        orderId
        eventId
        createdAt
        updatedAt
        productStockReservationsId
        eventProductStockReservationsId
        companyStockReservationsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchStockReservations = /* GraphQL */ `
  query SearchStockReservations(
    $filter: SearchableStockReservationFilterInput
    $sort: [SearchableStockReservationSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableStockReservationAggregationInput]
  ) {
    searchStockReservations(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProduct {
          id
          price
          stock
          isAvailable
          sortKey
          boothPriceRule
          createdAt
          updatedAt
          productEventProductsId
          eventEventProductsId
          __typename
        }
        qty
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        reservationDate
        reservationEndDate
        boothNumber
        orderId
        eventId
        createdAt
        updatedAt
        productStockReservationsId
        eventProductStockReservationsId
        companyStockReservationsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getIndustry = /* GraphQL */ `
  query GetIndustry($id: ID!) {
    getIndustry(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      subTitle {
        language
        text
        __typename
      }
      handle
      domain
      notificationEmailAddress
      primaryColor
      secondaryColor
      logo {
        fileName
        alt
        x4UUID
        __typename
      }
      favicon {
        fileName
        alt
        x4UUID
        __typename
      }
      sortKey
      status
      socialLinks {
        facebook
        x
        instagram
        spotify
        linkedin
        xing
        youtube
        pinterest
        snapchat
        tiktok
        __typename
      }
      events {
        items {
          id
          industryId
          eventId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availableProducts {
        items {
          id
          productId
          industryId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      lectures {
        items {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        nextToken
        __typename
      }
      orders {
        items {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        nextToken
        __typename
      }
      news {
        items {
          id
          cMSNewsId
          industryId
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      jetEngineAccess {
        baseurl
        username
        password
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIndustries = /* GraphQL */ `
  query ListIndustries(
    $filter: ModelIndustryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIndustries(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        subTitle {
          language
          text
          __typename
        }
        handle
        domain
        notificationEmailAddress
        primaryColor
        secondaryColor
        logo {
          fileName
          alt
          x4UUID
          __typename
        }
        favicon {
          fileName
          alt
          x4UUID
          __typename
        }
        sortKey
        status
        socialLinks {
          facebook
          x
          instagram
          spotify
          linkedin
          xing
          youtube
          pinterest
          snapchat
          tiktok
          __typename
        }
        events {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        orders {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        jetEngineAccess {
          baseurl
          username
          password
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const industriesByHandle = /* GraphQL */ `
  query IndustriesByHandle(
    $handle: String!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industriesByHandle(
      handle: $handle
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name {
          language
          text
          __typename
        }
        subTitle {
          language
          text
          __typename
        }
        handle
        domain
        notificationEmailAddress
        primaryColor
        secondaryColor
        logo {
          fileName
          alt
          x4UUID
          __typename
        }
        favicon {
          fileName
          alt
          x4UUID
          __typename
        }
        sortKey
        status
        socialLinks {
          facebook
          x
          instagram
          spotify
          linkedin
          xing
          youtube
          pinterest
          snapchat
          tiktok
          __typename
        }
        events {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        orders {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        jetEngineAccess {
          baseurl
          username
          password
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      slug
      slugHistory
      description {
        language
        text
        __typename
      }
      shortDescription {
        language
        text
        __typename
      }
      industry
      status
      contact {
        phone
        mobile
        fax
        email
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        __typename
      }
      website
      image {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      banner {
        fileName
        alt
        x4UUID
        __typename
      }
      departments {
        items {
          id
          status
          x4Name
          createdAt
          updatedAt
          companyDepartmentsId
          __typename
        }
        nextToken
        __typename
      }
      attendingEvents {
        items {
          id
          companyId
          eventId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      employees {
        items {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        nextToken
        __typename
      }
      employmentRequests {
        items {
          id
          initiator
          role
          permissions
          status
          temporaryPassword
          newCognitoUserCreated
          createdAt
          updatedAt
          companyEmploymentRequestsId
          userEmploymentRequestsId
          owner
          __typename
        }
        nextToken
        __typename
      }
      admin {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      adminEmployees {
        items {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        nextToken
        __typename
      }
      admins
      x4Id
      x4AdminId
      todos {
        items {
          id
          title
          description
          status
          dueDate
          startDate
          priority
          createdAt
          updatedAt
          companyTodosId
          userTodosId
          owner
          __typename
        }
        nextToken
        __typename
      }
      news {
        items {
          id
          type
          slug
          slugHistory
          adminComment
          approved
          status
          isHero
          isHero2
          createdAt
          updatedAt
          companyNewsId
          employeeNewsId
          cMSNewsEmployeeId
          cMSNewsTopicId
          owner
          __typename
        }
        nextToken
        __typename
      }
      products {
        items {
          id
          slug
          slugHistory
          type
          adminComment
          approved
          status
          createdAt
          updatedAt
          companyProductsId
          cMSProductEmployeeId
          cMSProductTopicId
          owner
          __typename
        }
        nextToken
        __typename
      }
      jobs {
        items {
          id
          slug
          slugHistory
          adminComment
          approved
          status
          createdAt
          updatedAt
          companyJobsId
          cMSJobListingEmployeeId
          owner
          __typename
        }
        nextToken
        __typename
      }
      topics {
        items {
          id
          topicId
          companyId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      keywords
      lectures {
        items {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        nextToken
        __typename
      }
      billingContact {
        phone
        mobile
        fax
        email
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        __typename
      }
      billingSettings {
        orderNumberRequired
        __typename
      }
      orders {
        items {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        nextToken
        __typename
      }
      tourRegistrations {
        items {
          id
          date
          status
          createdAt
          updatedAt
          cMSTourTourCompanyRegistrationsId
          companyTourRegistrationsId
          employeeTourRegistrationsId
          cMSTourCompanyRegistrationCompanyId
          cMSTourCompanyRegistrationEmployeeId
          owner
          __typename
        }
        nextToken
        __typename
      }
      tourVisitorRegistrations {
        items {
          id
          date
          status
          createdAt
          updatedAt
          cMSTourTourVisitorRegistrationsId
          companyTourVisitorRegistrationsId
          userTourRegistrationsId
          owner
          __typename
        }
        nextToken
        __typename
      }
      invitationCodes {
        items {
          id
          createdByAdmin
          code
          createdAt
          updatedAt
          companyInvitationCodesId
          eventInvitationCodesId
          invitationCodeDiscountCodeId
          owner
          __typename
        }
        nextToken
        __typename
      }
      stockReservations {
        items {
          id
          qty
          status
          reservationDate
          reservationEndDate
          boothNumber
          orderId
          eventId
          createdAt
          updatedAt
          productStockReservationsId
          eventProductStockReservationsId
          companyStockReservationsId
          __typename
        }
        nextToken
        __typename
      }
      bookedBooths {
        items {
          id
          type
          boothNumber
          status
          createdAt
          updatedAt
          companyBookedBoothsId
          eventBookedBoothsId
          bookedBoothOrderLineItemId
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyAdminId
      __typename
    }
  }
`;
export const listCompanies = /* GraphQL */ `
  query ListCompanies(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companiesBySlug = /* GraphQL */ `
  query CompaniesBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchCompanies = /* GraphQL */ `
  query SearchCompanies(
    $filter: SearchableCompanyFilterInput
    $sort: [SearchableCompanySortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableCompanyAggregationInput]
  ) {
    searchCompanies(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getEmployee = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      user {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      department {
        items {
          id
          employeeId
          departmentId
          createdAt
          updatedAt
          userCognitoId
          __typename
        }
        nextToken
        __typename
      }
      contact {
        phone
        mobile
        fax
        email
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        __typename
      }
      role
      permissions {
        resource
        actions
        __typename
      }
      status
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      x4Id
      News {
        items {
          id
          type
          slug
          slugHistory
          adminComment
          approved
          status
          isHero
          isHero2
          createdAt
          updatedAt
          companyNewsId
          employeeNewsId
          cMSNewsEmployeeId
          cMSNewsTopicId
          owner
          __typename
        }
        nextToken
        __typename
      }
      WPJetEngineId
      lectures {
        items {
          id
          lectureId
          employeeId
          createdAt
          updatedAt
          usersCanEdit
          userCognitoId
          __typename
        }
        nextToken
        __typename
      }
      userCognitoId
      tourRegistrations {
        items {
          id
          date
          status
          createdAt
          updatedAt
          cMSTourTourCompanyRegistrationsId
          companyTourRegistrationsId
          employeeTourRegistrationsId
          cMSTourCompanyRegistrationCompanyId
          cMSTourCompanyRegistrationEmployeeId
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      companyEmployeesId
      companyAdminEmployeesId
      userEmployeeProfilesId
      __typename
    }
  }
`;
export const listEmployees = /* GraphQL */ `
  query ListEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchEmployees = /* GraphQL */ `
  query SearchEmployees(
    $filter: SearchableEmployeeFilterInput
    $sort: [SearchableEmployeeSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableEmployeeAggregationInput]
  ) {
    searchEmployees(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getEmploymentRequest = /* GraphQL */ `
  query GetEmploymentRequest($id: ID!) {
    getEmploymentRequest(id: $id) {
      id
      user {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      requestingUser {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      initiator
      department {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        status
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employees {
          nextToken
          __typename
        }
        x4Name
        createdAt
        updatedAt
        companyDepartmentsId
        __typename
      }
      contact {
        phone
        mobile
        fax
        email
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        __typename
      }
      role
      permissions
      status
      temporaryPassword
      newCognitoUserCreated
      createdAt
      updatedAt
      companyEmploymentRequestsId
      userEmploymentRequestsId
      owner
      __typename
    }
  }
`;
export const listEmploymentRequests = /* GraphQL */ `
  query ListEmploymentRequests(
    $filter: ModelEmploymentRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmploymentRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        requestingUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        initiator
        department {
          id
          status
          x4Name
          createdAt
          updatedAt
          companyDepartmentsId
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions
        status
        temporaryPassword
        newCognitoUserCreated
        createdAt
        updatedAt
        companyEmploymentRequestsId
        userEmploymentRequestsId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      owner
      id
      email
      firstName
      middleName
      lastName
      salutation
      title
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      birthday
      aboutMe {
        language
        text
        __typename
      }
      contact {
        phone
        mobile
        fax
        email
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        __typename
      }
      personalIndustry
      personalDepartment
      language
      employeeProfiles {
        items {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        nextToken
        __typename
      }
      x4Id
      pw_hash
      hasCompletedOnboarding
      conditions {
        id
        accepted
        acceptedAt
        __typename
      }
      employmentRequests {
        items {
          id
          initiator
          role
          permissions
          status
          temporaryPassword
          newCognitoUserCreated
          createdAt
          updatedAt
          companyEmploymentRequestsId
          userEmploymentRequestsId
          owner
          __typename
        }
        nextToken
        __typename
      }
      todos {
        items {
          id
          title
          description
          status
          dueDate
          startDate
          priority
          createdAt
          updatedAt
          companyTodosId
          userTodosId
          owner
          __typename
        }
        nextToken
        __typename
      }
      tickets {
        items {
          owner
          id
          industryId
          createdByUserId
          userTicketsId
          eventDays
          status
          paymentStatus
          type
          visitorType
          addons
          notes
          billingEmail
          invitationCode
          orderNumber
          firstName
          lastName
          companyName
          isFreeTicket
          createdAt
          updatedAt
          ticketEventId
          ticketCompanyId
          ticketPaymentId
          __typename
        }
        nextToken
        __typename
      }
      status
      orders {
        items {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        nextToken
        __typename
      }
      tourRegistrations {
        items {
          id
          date
          status
          createdAt
          updatedAt
          cMSTourTourVisitorRegistrationsId
          companyTourVisitorRegistrationsId
          userTourRegistrationsId
          owner
          __typename
        }
        nextToken
        __typename
      }
      hasInsightAccess
      videoProgress {
        items {
          id
          userId
          videoId
          progressInSeconds
          totalWatchedInSeconds
          createdAt
          updatedAt
          lectureVideoProgressId
          userVideoProgressId
          __typename
        }
        nextToken
        __typename
      }
      lectures {
        items {
          id
          lectureId
          userId
          createdAt
          updatedAt
          usersCanEdit
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      seminarSpeakersId
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: [SearchableUserSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableUserAggregationInput]
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      type
      boothBooking
      boothBookingStart
      boothBookingEnd
      name {
        language
        text
        __typename
      }
      slug
      slugHistory
      description {
        language
        text
        __typename
      }
      status
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      date
      startDate
      endDate
      startTime
      endTime
      daySchedules {
        day
        date
        exhibitorStart
        exhibitorEnd
        visitorStart
        visitorEnd
        note {
          language
          text
          __typename
        }
        __typename
      }
      location {
        name {
          language
          text
          __typename
        }
        travelAndParkingNotice {
          language
          text
          __typename
        }
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        coordinates {
          lat
          lng
          __typename
        }
        __typename
      }
      lectureRooms
      lectureRegistrationStartDate
      lectureRegistrationEndDate
      lectureEditEndDate
      lectureDocumentsEndDate
      lecturePresentationEndDate
      lectureRecordingCorrectionEndDate
      actionRegistrationStartDate
      actionRegistrationEndDate
      actionEditEndDate
      deadlineBoothEquipmentPrint
      carpetColorSelectionEndDate
      startBoothEquipmentBooking
      deadlineBoothEquipmentBooking
      startBoothMarketingBooking
      deadlineBoothMarketingBooking
      availableLectureTypes
      floorPlan {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      boothPlan {
        image {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        width
        height
        areasUpdatedAt
        viewBox
        activeVersionId
        __typename
      }
      program {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      landingPageUrl
      attendees {
        items {
          id
          companyId
          eventId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availableBundleBooths {
        items {
          id
          bundleBoothId
          eventId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      availableProducts {
        items {
          id
          productId
          eventId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      ticketProduct {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      eventProducts {
        items {
          id
          price
          stock
          isAvailable
          sortKey
          boothPriceRule
          createdAt
          updatedAt
          productEventProductsId
          eventEventProductsId
          __typename
        }
        nextToken
        __typename
      }
      lectures {
        items {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        nextToken
        __typename
      }
      tours {
        items {
          id
          fromDate
          toDate
          createdAt
          updatedAt
          eventToursId
          owner
          __typename
        }
        nextToken
        __typename
      }
      invitationCodes {
        items {
          id
          createdByAdmin
          code
          createdAt
          updatedAt
          companyInvitationCodesId
          eventInvitationCodesId
          invitationCodeDiscountCodeId
          owner
          __typename
        }
        nextToken
        __typename
      }
      bookedBooths {
        items {
          id
          type
          boothNumber
          status
          createdAt
          updatedAt
          companyBookedBoothsId
          eventBookedBoothsId
          bookedBoothOrderLineItemId
          __typename
        }
        nextToken
        __typename
      }
      availableCarpets {
        items {
          id
          eventId
          eventCarpetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      highlightedPersons {
        userid
        text {
          language
          text
          __typename
        }
        __typename
      }
      industries {
        items {
          id
          industryId
          eventId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      x4Id
      WPJetEngineId
      orders {
        items {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        nextToken
        __typename
      }
      publicVideos
      bookingTicketBulletPoints {
        text {
          language
          text
          __typename
        }
        __typename
      }
      hasInvitationCodes
      invitationCodeRequired
      suggestedInvitationCode
      badgePreview {
        fileName
        alt
        x4UUID
        __typename
      }
      bookingSelectDays
      ticketTAC {
        language
        text
        __typename
      }
      ticketPrivacyPolicy {
        language
        text
        __typename
      }
      boothTAC {
        language
        text
        __typename
      }
      boothPrivacyPolicy {
        language
        text
        __typename
      }
      instantPaymentOnly
      autoGenerateInvoice
      paymentFlow
      ticketPricePerDay
      enableTicketBooking
      enableStaffBooking
      allowCompanyToBookTickets
      ticketCancellationDeadline
      ticketNotice {
        language
        text
        __typename
      }
      ticketOrganizerLine {
        language
        text
        __typename
      }
      bookingNotice {
        language
        text
        __typename
      }
      exhibitorLectures
      lecturesNotice {
        language
        text
        __typename
      }
      landingPageIntroText {
        language
        text
        __typename
      }
      landingPageProgramText {
        language
        text
        __typename
      }
      landingPageProgramSpeakersTitle {
        language
        text
        __typename
      }
      landingPageProgramSpeakersText {
        language
        text
        __typename
      }
      landingPageBookingText {
        language
        text
        __typename
      }
      landingPageBookingPandCText {
        language
        text
        __typename
      }
      heroBannerStats {
        language
        text
        __typename
      }
      infoTextExhibitors {
        language
        text
        __typename
      }
      infoTextVisitors {
        language
        text
        __typename
      }
      infoTextTravel {
        language
        text
        __typename
      }
      contactPersons {
        name
        department
        phone
        email
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      documents {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      highlights {
        mainVideo {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        mainText {
          language
          text
          __typename
        }
        dailys {
          date
          __typename
        }
        images {
          tags
          __typename
        }
        videos {
          tags
          __typename
        }
        pressMedia {
          __typename
        }
        exhibitorInfo {
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      eventTicketProductId
      __typename
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventsBySlug = /* GraphQL */ `
  query EventsBySlug(
    $slug: String!
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventsBySlug(
      slug: $slug
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEventCarpet = /* GraphQL */ `
  query GetEventCarpet($id: ID!) {
    getEventCarpet(id: $id) {
      id
      order
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      color
      image {
        fileName
        alt
        x4UUID
        __typename
      }
      availableInEvents {
        items {
          id
          eventId
          eventCarpetId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEventCarpets = /* GraphQL */ `
  query ListEventCarpets(
    $filter: ModelEventCarpetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventCarpets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        order
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        color
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getDepartment = /* GraphQL */ `
  query GetDepartment($id: ID!) {
    getDepartment(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      status
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      employees {
        items {
          id
          employeeId
          departmentId
          createdAt
          updatedAt
          userCognitoId
          __typename
        }
        nextToken
        __typename
      }
      x4Name
      createdAt
      updatedAt
      companyDepartmentsId
      __typename
    }
  }
`;
export const listDepartments = /* GraphQL */ `
  query ListDepartments(
    $filter: ModelDepartmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDepartments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        status
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employees {
          nextToken
          __typename
        }
        x4Name
        createdAt
        updatedAt
        companyDepartmentsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchDepartments = /* GraphQL */ `
  query SearchDepartments(
    $filter: SearchableDepartmentFilterInput
    $sort: [SearchableDepartmentSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableDepartmentAggregationInput]
  ) {
    searchDepartments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        status
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employees {
          nextToken
          __typename
        }
        x4Name
        createdAt
        updatedAt
        companyDepartmentsId
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getPrint = /* GraphQL */ `
  query GetPrint($id: ID!) {
    getPrint(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      dimensions
      type
      images {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      file {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      bundleBoothAvailablePrintsId
      __typename
    }
  }
`;
export const listPrints = /* GraphQL */ `
  query ListPrints(
    $filter: ModelPrintFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPrints(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        dimensions
        type
        images {
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvailablePrintsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getFloor = /* GraphQL */ `
  query GetFloor($id: ID!) {
    getFloor(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      color
      images {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      bundleBoothAvaiableFloorsId
      __typename
    }
  }
`;
export const listFloors = /* GraphQL */ `
  query ListFloors(
    $filter: ModelFloorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFloors(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        color
        images {
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableFloorsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getMarketingPackage = /* GraphQL */ `
  query GetMarketingPackage($id: ID!) {
    getMarketingPackage(id: $id) {
      id
      name {
        language
        text
        __typename
      }
      description {
        language
        text
        __typename
      }
      images {
        main {
          fileName
          alt
          x4UUID
          __typename
        }
        additional {
          fileName
          alt
          x4UUID
          __typename
        }
        __typename
      }
      features {
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listMarketingPackages = /* GraphQL */ `
  query ListMarketingPackages(
    $filter: ModelMarketingPackageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMarketingPackages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        images {
          __typename
        }
        features {
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBookingBundleBooth = /* GraphQL */ `
  query GetBookingBundleBooth($id: ID!) {
    getBookingBundleBooth(id: $id) {
      id
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      createdBy {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      booth {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        sku
        boothNumber
        availableInEvents {
          nextToken
          __typename
        }
        price
        images {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        status
        availablePrints {
          nextToken
          __typename
        }
        avaiableFloors {
          nextToken
          __typename
        }
        avaiableAccessories {
          nextToken
          __typename
        }
        includedMarketingPackage {
          id
          createdAt
          updatedAt
          __typename
        }
        includedAccessories {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      status
      totalAmount
      printFiles {
        url
        publicUrl
        s3Path
        fileName
        type
        name
        createdAt
        updatedAt
        __typename
      }
      floor {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        color
        images {
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableFloorsId
        __typename
      }
      accessories {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      marketingPackage {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        images {
          __typename
        }
        features {
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBookingBundleBooths = /* GraphQL */ `
  query ListBookingBundleBooths(
    $filter: ModelBookingBundleBoothFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBookingBundleBooths(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        createdBy {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        booth {
          id
          sku
          boothNumber
          price
          status
          createdAt
          updatedAt
          __typename
        }
        status
        totalAmount
        printFiles {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        floor {
          id
          color
          createdAt
          updatedAt
          bundleBoothAvaiableFloorsId
          __typename
        }
        accessories {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        marketingPackage {
          id
          createdAt
          updatedAt
          __typename
        }
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getToDo = /* GraphQL */ `
  query GetToDo($id: ID!) {
    getToDo(id: $id) {
      id
      user {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      title
      description
      status
      dueDate
      startDate
      priority
      createdBy {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      createdAt
      updatedAt
      companyTodosId
      userTodosId
      owner
      __typename
    }
  }
`;
export const listToDos = /* GraphQL */ `
  query ListToDos(
    $filter: ModelToDoFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listToDos(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        title
        description
        status
        dueDate
        startDate
        priority
        createdBy {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        createdAt
        updatedAt
        companyTodosId
        userTodosId
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getVerificationCode = /* GraphQL */ `
  query GetVerificationCode($id: ID!) {
    getVerificationCode(id: $id) {
      id
      code
      userId
      type
      status
      expirationDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listVerificationCodes = /* GraphQL */ `
  query ListVerificationCodes(
    $filter: ModelVerificationCodeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVerificationCodes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        code
        userId
        type
        status
        expirationDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSystemDocumentSettings = /* GraphQL */ `
  query GetSystemDocumentSettings(
    $documentType: String!
    $industryId: String!
  ) {
    getSystemDocumentSettings(
      documentType: $documentType
      industryId: $industryId
    ) {
      documentType
      industryId
      name
      logo {
        fileName
        alt
        x4UUID
        __typename
      }
      companyName
      companyAddress {
        firstName
        lastName
        title
        salutation
        street
        street2
        streetNumber
        company
        contactPerson
        city
        zip
        countryCode
        __typename
      }
      companyContact {
        phone
        mobile
        fax
        email
        address {
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        __typename
      }
      website
      bank {
        accountHolder
        iban
        bic
        bankName
        __typename
      }
      taxid
      legalNotice {
        short
        html
        __typename
      }
      dueDays
      prefix
      digits
      lastNumber
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSystemDocumentSettings = /* GraphQL */ `
  query ListSystemDocumentSettings(
    $documentType: String
    $industryId: ModelStringKeyConditionInput
    $filter: ModelSystemDocumentSettingsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSystemDocumentSettings(
      documentType: $documentType
      industryId: $industryId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        documentType
        industryId
        name
        logo {
          fileName
          alt
          x4UUID
          __typename
        }
        companyName
        companyAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        companyContact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        bank {
          accountHolder
          iban
          bic
          bankName
          __typename
        }
        taxid
        legalNotice {
          short
          html
          __typename
        }
        dueDays
        prefix
        digits
        lastNumber
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLog = /* GraphQL */ `
  query GetLog($id: ID!) {
    getLog(id: $id) {
      id
      timestamp
      type
      message
      user
      ip
      userAgent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listLogs = /* GraphQL */ `
  query ListLogs(
    $filter: ModelLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        timestamp
        type
        message
        user
        ip
        userAgent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const searchLogs = /* GraphQL */ `
  query SearchLogs(
    $filter: SearchableLogFilterInput
    $sort: [SearchableLogSortInput]
    $limit: Int
    $nextToken: String
    $from: Int
    $aggregates: [SearchableLogAggregationInput]
  ) {
    searchLogs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
      from: $from
      aggregates: $aggregates
    ) {
      items {
        id
        timestamp
        type
        message
        user
        ip
        userAgent
        createdAt
        updatedAt
        __typename
      }
      nextToken
      total
      aggregateItems {
        name
        result {
          ... on SearchableAggregateScalarResult {
            value
          }
          ... on SearchableAggregateBucketResult {
            buckets {
              key
              doc_count
              __typename
            }
          }
        }
        __typename
      }
      __typename
    }
  }
`;
export const getLecturesInCourses = /* GraphQL */ `
  query GetLecturesInCourses($id: ID!) {
    getLecturesInCourses(id: $id) {
      id
      courseId
      lectureId
      course {
        id
        name {
          language
          text
          __typename
        }
        sortKey
        lectures {
          nextToken
          __typename
        }
        videos
        shortDescription {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        type
        duration
        price
        topics {
          language
          text
          __typename
        }
        speakersDescription {
          language
          text
          __typename
        }
        CTADescription {
          language
          text
          __typename
        }
        CTABulletPoints {
          __typename
        }
        WPJetEngineId
        academyTopics {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      lecture {
        id
        usersCanEdit
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        companyBooth
        speakers {
          nextToken
          __typename
        }
        speakersUsers {
          nextToken
          __typename
        }
        session
        mainSpeaker {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        mainSpeakerUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        room
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        subjects {
          id
          __typename
        }
        speakerAffiliations {
          speakerId
          source
          companyId
          companyName
          __typename
        }
        topics {
          nextToken
          __typename
        }
        content {
          language
          text
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        presentationLanguage
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        pdfDe {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        pdfEn {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        videoS3Key {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        presentation {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        adminComment
        adminTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        approved
        approvedInsight
        lengthInSeconds
        status
        videoProgress {
          nextToken
          __typename
        }
        courses {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarLecturesId
        industryLecturesId
        companyLecturesId
        eventLecturesId
        lectureMainSpeakerId
        lectureMainSpeakerUserId
        lectureAdminTopicId
        __typename
      }
      createdAt
      updatedAt
      usersCanEdit
      __typename
    }
  }
`;
export const listLecturesInCourses = /* GraphQL */ `
  query ListLecturesInCourses(
    $filter: ModelLecturesInCoursesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLecturesInCourses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseId
        lectureId
        course {
          id
          sortKey
          videos
          type
          duration
          price
          WPJetEngineId
          createdAt
          updatedAt
          __typename
        }
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesInCoursesByCourseId = /* GraphQL */ `
  query LecturesInCoursesByCourseId(
    $courseId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLecturesInCoursesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesInCoursesByCourseId(
      courseId: $courseId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseId
        lectureId
        course {
          id
          sortKey
          videos
          type
          duration
          price
          WPJetEngineId
          createdAt
          updatedAt
          __typename
        }
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesInCoursesByLectureId = /* GraphQL */ `
  query LecturesInCoursesByLectureId(
    $lectureId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLecturesInCoursesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesInCoursesByLectureId(
      lectureId: $lectureId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseId
        lectureId
        course {
          id
          sortKey
          videos
          type
          duration
          price
          WPJetEngineId
          createdAt
          updatedAt
          __typename
        }
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCoursesAcademyTopics = /* GraphQL */ `
  query GetCoursesAcademyTopics($id: ID!) {
    getCoursesAcademyTopics(id: $id) {
      id
      courseId
      academyTopicId
      course {
        id
        name {
          language
          text
          __typename
        }
        sortKey
        lectures {
          nextToken
          __typename
        }
        videos
        shortDescription {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        type
        duration
        price
        topics {
          language
          text
          __typename
        }
        speakersDescription {
          language
          text
          __typename
        }
        CTADescription {
          language
          text
          __typename
        }
        CTABulletPoints {
          __typename
        }
        WPJetEngineId
        academyTopics {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      academyTopic {
        id
        name {
          language
          text
          __typename
        }
        color
        sortKey
        academyTopicGroup {
          id
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        courses {
          nextToken
          __typename
        }
        seminars {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        academyTopicGroupAcademyTopicsId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCoursesAcademyTopics = /* GraphQL */ `
  query ListCoursesAcademyTopics(
    $filter: ModelCoursesAcademyTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoursesAcademyTopics(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseId
        academyTopicId
        course {
          id
          sortKey
          videos
          type
          duration
          price
          WPJetEngineId
          createdAt
          updatedAt
          __typename
        }
        academyTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          academyTopicGroupAcademyTopicsId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const coursesAcademyTopicsByCourseId = /* GraphQL */ `
  query CoursesAcademyTopicsByCourseId(
    $courseId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCoursesAcademyTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    coursesAcademyTopicsByCourseId(
      courseId: $courseId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseId
        academyTopicId
        course {
          id
          sortKey
          videos
          type
          duration
          price
          WPJetEngineId
          createdAt
          updatedAt
          __typename
        }
        academyTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          academyTopicGroupAcademyTopicsId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const coursesAcademyTopicsByAcademyTopicId = /* GraphQL */ `
  query CoursesAcademyTopicsByAcademyTopicId(
    $academyTopicId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCoursesAcademyTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    coursesAcademyTopicsByAcademyTopicId(
      academyTopicId: $academyTopicId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        courseId
        academyTopicId
        course {
          id
          sortKey
          videos
          type
          duration
          price
          WPJetEngineId
          createdAt
          updatedAt
          __typename
        }
        academyTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          academyTopicGroupAcademyTopicsId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSeminarAcademyTopics = /* GraphQL */ `
  query GetSeminarAcademyTopics($id: ID!) {
    getSeminarAcademyTopics(id: $id) {
      id
      academyTopicId
      seminarId
      academyTopic {
        id
        name {
          language
          text
          __typename
        }
        color
        sortKey
        academyTopicGroup {
          id
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        courses {
          nextToken
          __typename
        }
        seminars {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        academyTopicGroupAcademyTopicsId
        __typename
      }
      seminar {
        id
        name {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        cover {
          fileName
          alt
          x4UUID
          __typename
        }
        seminarDays {
          date
          startTime
          endTime
          __typename
        }
        location {
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        speakers {
          nextToken
          __typename
        }
        CTABulletPoints {
          __typename
        }
        bookingStartDate
        bookingEndDate
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        academyTopics {
          nextToken
          __typename
        }
        status
        sortKey
        WPJetEngineId
        createdAt
        updatedAt
        seminarProductId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSeminarAcademyTopics = /* GraphQL */ `
  query ListSeminarAcademyTopics(
    $filter: ModelSeminarAcademyTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSeminarAcademyTopics(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        academyTopicId
        seminarId
        academyTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          academyTopicGroupAcademyTopicsId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const seminarAcademyTopicsByAcademyTopicId = /* GraphQL */ `
  query SeminarAcademyTopicsByAcademyTopicId(
    $academyTopicId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSeminarAcademyTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    seminarAcademyTopicsByAcademyTopicId(
      academyTopicId: $academyTopicId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        academyTopicId
        seminarId
        academyTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          academyTopicGroupAcademyTopicsId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const seminarAcademyTopicsBySeminarId = /* GraphQL */ `
  query SeminarAcademyTopicsBySeminarId(
    $seminarId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSeminarAcademyTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    seminarAcademyTopicsBySeminarId(
      seminarId: $seminarId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        academyTopicId
        seminarId
        academyTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          academyTopicGroupAcademyTopicsId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrderProducts = /* GraphQL */ `
  query GetOrderProducts($id: ID!) {
    getOrderProducts(id: $id) {
      id
      orderId
      productId
      order {
        id
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        type
        orderNumber
        buyerOrderNumber
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        status
        paymentStatus
        deliveryStatus
        products {
          nextToken
          __typename
        }
        lineItems {
          nextToken
          __typename
        }
        notes
        deliveryAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingAddress {
          firstName
          lastName
          title
          salutation
          street
          street2
          streetNumber
          company
          contactPerson
          city
          zip
          countryCode
          __typename
        }
        billingEmail
        financial {
          id
          isBusiness
          isInterEUDelivery
          currency
          invoiceAmount
          invoiceAmountNet
          invoiceNumber
          invoiceDate
          invoiceLastSent
          invoiceReceivers
          servicePeriodStart
          servicePeriodEnd
          taxRate
          shippingCost
          shippingCostNet
          paymentCost
          discountCode
          discountAmount
          discountType
          paymentProvider
          stripeSessionId
          totalAmount
          createdAt
          updatedAt
          orderFinancialOrderId
          __typename
        }
        data
        totalAmount
        createdAt
        updatedAt
        industryOrdersId
        companyOrdersId
        userOrdersId
        eventOrdersId
        orderFinancialId
        owner
        __typename
      }
      product {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listOrderProducts = /* GraphQL */ `
  query ListOrderProducts(
    $filter: ModelOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrderProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orderId
        productId
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orderProductsByOrderId = /* GraphQL */ `
  query OrderProductsByOrderId(
    $orderId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderProductsByOrderId(
      orderId: $orderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        productId
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const orderProductsByProductId = /* GraphQL */ `
  query OrderProductsByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrderProductsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    orderProductsByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orderId
        productId
        order {
          id
          type
          orderNumber
          buyerOrderNumber
          status
          paymentStatus
          deliveryStatus
          notes
          billingEmail
          data
          totalAmount
          createdAt
          updatedAt
          industryOrdersId
          companyOrdersId
          userOrdersId
          eventOrdersId
          orderFinancialId
          owner
          __typename
        }
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAvailableBundleBoothsInEvents = /* GraphQL */ `
  query GetAvailableBundleBoothsInEvents($id: ID!) {
    getAvailableBundleBoothsInEvents(id: $id) {
      id
      bundleBoothId
      eventId
      bundleBooth {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        sku
        boothNumber
        availableInEvents {
          nextToken
          __typename
        }
        price
        images {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        status
        availablePrints {
          nextToken
          __typename
        }
        avaiableFloors {
          nextToken
          __typename
        }
        avaiableAccessories {
          nextToken
          __typename
        }
        includedMarketingPackage {
          id
          createdAt
          updatedAt
          __typename
        }
        includedAccessories {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAvailableBundleBoothsInEvents = /* GraphQL */ `
  query ListAvailableBundleBoothsInEvents(
    $filter: ModelAvailableBundleBoothsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAvailableBundleBoothsInEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        bundleBoothId
        eventId
        bundleBooth {
          id
          sku
          boothNumber
          price
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const availableBundleBoothsInEventsByBundleBoothId = /* GraphQL */ `
  query AvailableBundleBoothsInEventsByBundleBoothId(
    $bundleBoothId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailableBundleBoothsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availableBundleBoothsInEventsByBundleBoothId(
      bundleBoothId: $bundleBoothId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        bundleBoothId
        eventId
        bundleBooth {
          id
          sku
          boothNumber
          price
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const availableBundleBoothsInEventsByEventId = /* GraphQL */ `
  query AvailableBundleBoothsInEventsByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailableBundleBoothsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availableBundleBoothsInEventsByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        bundleBoothId
        eventId
        bundleBooth {
          id
          sku
          boothNumber
          price
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCompaniesTopics = /* GraphQL */ `
  query GetCompaniesTopics($id: ID!) {
    getCompaniesTopics(id: $id) {
      id
      topicId
      companyId
      topic {
        id
        name {
          language
          text
          __typename
        }
        color
        topicGroup {
          id
          industryId
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        companies {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        topicGroupTopicsId
        __typename
      }
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompaniesTopics = /* GraphQL */ `
  query ListCompaniesTopics(
    $filter: ModelCompaniesTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompaniesTopics(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        topicId
        companyId
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companiesTopicsByTopicId = /* GraphQL */ `
  query CompaniesTopicsByTopicId(
    $topicId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesTopicsByTopicId(
      topicId: $topicId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        topicId
        companyId
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companiesTopicsByCompanyId = /* GraphQL */ `
  query CompaniesTopicsByCompanyId(
    $companyId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesTopicsByCompanyId(
      companyId: $companyId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        topicId
        companyId
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLecturesTopics = /* GraphQL */ `
  query GetLecturesTopics($id: ID!) {
    getLecturesTopics(id: $id) {
      id
      topicId
      lectureId
      topic {
        id
        name {
          language
          text
          __typename
        }
        color
        topicGroup {
          id
          industryId
          color
          sortKey
          createdAt
          updatedAt
          __typename
        }
        companies {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        sortKey
        createdAt
        updatedAt
        topicGroupTopicsId
        __typename
      }
      lecture {
        id
        usersCanEdit
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        companyBooth
        speakers {
          nextToken
          __typename
        }
        speakersUsers {
          nextToken
          __typename
        }
        session
        mainSpeaker {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        mainSpeakerUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        room
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        subjects {
          id
          __typename
        }
        speakerAffiliations {
          speakerId
          source
          companyId
          companyName
          __typename
        }
        topics {
          nextToken
          __typename
        }
        content {
          language
          text
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        presentationLanguage
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        pdfDe {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        pdfEn {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        videoS3Key {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        presentation {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        adminComment
        adminTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        approved
        approvedInsight
        lengthInSeconds
        status
        videoProgress {
          nextToken
          __typename
        }
        courses {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarLecturesId
        industryLecturesId
        companyLecturesId
        eventLecturesId
        lectureMainSpeakerId
        lectureMainSpeakerUserId
        lectureAdminTopicId
        __typename
      }
      createdAt
      updatedAt
      usersCanEdit
      __typename
    }
  }
`;
export const listLecturesTopics = /* GraphQL */ `
  query ListLecturesTopics(
    $filter: ModelLecturesTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLecturesTopics(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        topicId
        lectureId
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesTopicsByTopicId = /* GraphQL */ `
  query LecturesTopicsByTopicId(
    $topicId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLecturesTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesTopicsByTopicId(
      topicId: $topicId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        topicId
        lectureId
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesTopicsByLectureId = /* GraphQL */ `
  query LecturesTopicsByLectureId(
    $lectureId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLecturesTopicsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesTopicsByLectureId(
      lectureId: $lectureId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        topicId
        lectureId
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIndustryNews = /* GraphQL */ `
  query GetIndustryNews($id: ID!) {
    getIndustryNews(id: $id) {
      id
      cMSNewsId
      industryId
      cMSNews {
        id
        industries {
          nextToken
          __typename
        }
        type
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        topic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        excerpt {
          language
          text
          __typename
        }
        interests {
          id
          createdAt
          updatedAt
          __typename
        }
        content {
          language
          text
          __typename
        }
        file {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        file3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        adminComment
        approved
        status
        isHero
        isHero2
        industryCMSItemIds {
          cms
          industryId
          itemId
          itemIds
          __typename
        }
        createdAt
        updatedAt
        companyNewsId
        employeeNewsId
        cMSNewsEmployeeId
        cMSNewsTopicId
        owner
        __typename
      }
      industry {
        id
        name {
          language
          text
          __typename
        }
        subTitle {
          language
          text
          __typename
        }
        handle
        domain
        notificationEmailAddress
        primaryColor
        secondaryColor
        logo {
          fileName
          alt
          x4UUID
          __typename
        }
        favicon {
          fileName
          alt
          x4UUID
          __typename
        }
        sortKey
        status
        socialLinks {
          facebook
          x
          instagram
          spotify
          linkedin
          xing
          youtube
          pinterest
          snapchat
          tiktok
          __typename
        }
        events {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        orders {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        jetEngineAccess {
          baseurl
          username
          password
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
  }
`;
export const listIndustryNews = /* GraphQL */ `
  query ListIndustryNews(
    $filter: ModelIndustryNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIndustryNews(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cMSNewsId
        industryId
        cMSNews {
          id
          type
          slug
          slugHistory
          adminComment
          approved
          status
          isHero
          isHero2
          createdAt
          updatedAt
          companyNewsId
          employeeNewsId
          cMSNewsEmployeeId
          cMSNewsTopicId
          owner
          __typename
        }
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const industryNewsByCMSNewsId = /* GraphQL */ `
  query IndustryNewsByCMSNewsId(
    $cMSNewsId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industryNewsByCMSNewsId(
      cMSNewsId: $cMSNewsId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cMSNewsId
        industryId
        cMSNews {
          id
          type
          slug
          slugHistory
          adminComment
          approved
          status
          isHero
          isHero2
          createdAt
          updatedAt
          companyNewsId
          employeeNewsId
          cMSNewsEmployeeId
          cMSNewsTopicId
          owner
          __typename
        }
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const industryNewsByIndustryId = /* GraphQL */ `
  query IndustryNewsByIndustryId(
    $industryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryNewsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industryNewsByIndustryId(
      industryId: $industryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        cMSNewsId
        industryId
        cMSNews {
          id
          type
          slug
          slugHistory
          adminComment
          approved
          status
          isHero
          isHero2
          createdAt
          updatedAt
          companyNewsId
          employeeNewsId
          cMSNewsEmployeeId
          cMSNewsTopicId
          owner
          __typename
        }
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLecturesSpeakers = /* GraphQL */ `
  query GetLecturesSpeakers($id: ID!) {
    getLecturesSpeakers(id: $id) {
      id
      lectureId
      employeeId
      lecture {
        id
        usersCanEdit
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        companyBooth
        speakers {
          nextToken
          __typename
        }
        speakersUsers {
          nextToken
          __typename
        }
        session
        mainSpeaker {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        mainSpeakerUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        room
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        subjects {
          id
          __typename
        }
        speakerAffiliations {
          speakerId
          source
          companyId
          companyName
          __typename
        }
        topics {
          nextToken
          __typename
        }
        content {
          language
          text
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        presentationLanguage
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        pdfDe {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        pdfEn {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        videoS3Key {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        presentation {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        adminComment
        adminTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        approved
        approvedInsight
        lengthInSeconds
        status
        videoProgress {
          nextToken
          __typename
        }
        courses {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarLecturesId
        industryLecturesId
        companyLecturesId
        eventLecturesId
        lectureMainSpeakerId
        lectureMainSpeakerUserId
        lectureAdminTopicId
        __typename
      }
      employee {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      createdAt
      updatedAt
      usersCanEdit
      userCognitoId
      __typename
    }
  }
`;
export const listLecturesSpeakers = /* GraphQL */ `
  query ListLecturesSpeakers(
    $filter: ModelLecturesSpeakersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLecturesSpeakers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lectureId
        employeeId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        userCognitoId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesSpeakersByLectureId = /* GraphQL */ `
  query LecturesSpeakersByLectureId(
    $lectureId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLecturesSpeakersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesSpeakersByLectureId(
      lectureId: $lectureId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lectureId
        employeeId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        userCognitoId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesSpeakersByEmployeeId = /* GraphQL */ `
  query LecturesSpeakersByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLecturesSpeakersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesSpeakersByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lectureId
        employeeId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        userCognitoId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getLecturesSpeakerUsers = /* GraphQL */ `
  query GetLecturesSpeakerUsers($id: ID!) {
    getLecturesSpeakerUsers(id: $id) {
      id
      lectureId
      userId
      lecture {
        id
        usersCanEdit
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        type
        startTime
        endTime
        dateTimes
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        seminar {
          id
          bookingStartDate
          bookingEndDate
          status
          sortKey
          WPJetEngineId
          createdAt
          updatedAt
          seminarProductId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        companyBooth
        speakers {
          nextToken
          __typename
        }
        speakersUsers {
          nextToken
          __typename
        }
        session
        mainSpeaker {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        mainSpeakerUser {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        room
        title {
          language
          text
          __typename
        }
        slug
        slugHistory
        subjects {
          id
          __typename
        }
        speakerAffiliations {
          speakerId
          source
          companyId
          companyName
          __typename
        }
        topics {
          nextToken
          __typename
        }
        content {
          language
          text
          __typename
        }
        conditions {
          name
          accepted
          __typename
        }
        presentationLanguage
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        pdfDe {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        pdfEn {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        videoS3Key {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        presentation {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        adminComment
        adminTopic {
          id
          color
          sortKey
          createdAt
          updatedAt
          topicGroupTopicsId
          __typename
        }
        approved
        approvedInsight
        lengthInSeconds
        status
        videoProgress {
          nextToken
          __typename
        }
        courses {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarLecturesId
        industryLecturesId
        companyLecturesId
        eventLecturesId
        lectureMainSpeakerId
        lectureMainSpeakerUserId
        lectureAdminTopicId
        __typename
      }
      user {
        owner
        id
        email
        firstName
        middleName
        lastName
        salutation
        title
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        birthday
        aboutMe {
          language
          text
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        personalIndustry
        personalDepartment
        language
        employeeProfiles {
          nextToken
          __typename
        }
        x4Id
        pw_hash
        hasCompletedOnboarding
        conditions {
          id
          accepted
          acceptedAt
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        todos {
          nextToken
          __typename
        }
        tickets {
          nextToken
          __typename
        }
        status
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        hasInsightAccess
        videoProgress {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        seminarSpeakersId
        __typename
      }
      createdAt
      updatedAt
      usersCanEdit
      owner
      __typename
    }
  }
`;
export const listLecturesSpeakerUsers = /* GraphQL */ `
  query ListLecturesSpeakerUsers(
    $filter: ModelLecturesSpeakerUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLecturesSpeakerUsers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lectureId
        userId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesSpeakerUsersByLectureId = /* GraphQL */ `
  query LecturesSpeakerUsersByLectureId(
    $lectureId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLecturesSpeakerUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesSpeakerUsersByLectureId(
      lectureId: $lectureId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lectureId
        userId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const lecturesSpeakerUsersByUserId = /* GraphQL */ `
  query LecturesSpeakerUsersByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelLecturesSpeakerUsersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    lecturesSpeakerUsersByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        lectureId
        userId
        lecture {
          id
          usersCanEdit
          type
          startTime
          endTime
          dateTimes
          companyBooth
          session
          room
          slug
          slugHistory
          presentationLanguage
          adminComment
          approved
          approvedInsight
          lengthInSeconds
          status
          createdAt
          updatedAt
          seminarLecturesId
          industryLecturesId
          companyLecturesId
          eventLecturesId
          lectureMainSpeakerId
          lectureMainSpeakerUserId
          lectureAdminTopicId
          __typename
        }
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        createdAt
        updatedAt
        usersCanEdit
        owner
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAvailableProductsInIndustries = /* GraphQL */ `
  query GetAvailableProductsInIndustries($id: ID!) {
    getAvailableProductsInIndustries(id: $id) {
      id
      productId
      industryId
      product {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      industry {
        id
        name {
          language
          text
          __typename
        }
        subTitle {
          language
          text
          __typename
        }
        handle
        domain
        notificationEmailAddress
        primaryColor
        secondaryColor
        logo {
          fileName
          alt
          x4UUID
          __typename
        }
        favicon {
          fileName
          alt
          x4UUID
          __typename
        }
        sortKey
        status
        socialLinks {
          facebook
          x
          instagram
          spotify
          linkedin
          xing
          youtube
          pinterest
          snapchat
          tiktok
          __typename
        }
        events {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        orders {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        jetEngineAccess {
          baseurl
          username
          password
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAvailableProductsInIndustries = /* GraphQL */ `
  query ListAvailableProductsInIndustries(
    $filter: ModelAvailableProductsInIndustriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAvailableProductsInIndustries(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        industryId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const availableProductsInIndustriesByProductId = /* GraphQL */ `
  query AvailableProductsInIndustriesByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailableProductsInIndustriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availableProductsInIndustriesByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        industryId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const availableProductsInIndustriesByIndustryId = /* GraphQL */ `
  query AvailableProductsInIndustriesByIndustryId(
    $industryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailableProductsInIndustriesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availableProductsInIndustriesByIndustryId(
      industryId: $industryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        industryId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAvailableProductsInEvents = /* GraphQL */ `
  query GetAvailableProductsInEvents($id: ID!) {
    getAvailableProductsInEvents(id: $id) {
      id
      productId
      eventId
      product {
        id
        visibleInShop
        name {
          language
          text
          __typename
        }
        name_text
        category {
          id
          customerTypes
          sortKey
          createdAt
          updatedAt
          __typename
        }
        invoiceName {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        includes {
          language
          text
          __typename
        }
        sku
        ean
        type
        subType
        price
        downPaymentPrice
        image {
          __typename
        }
        features {
          __typename
        }
        files {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        orders {
          nextToken
          __typename
        }
        orderLineItems {
          nextToken
          __typename
        }
        allowedBuyerGroups
        requiredShipping
        icon
        stock
        stockReservations {
          nextToken
          __typename
        }
        availableInIndustries {
          nextToken
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        components {
          nextToken
          __typename
        }
        boothNumber
        boothVariant
        boothVariantAliases
        boothMatchRule
        boothPriceMode
        boothPriceRule
        boothArea
        boothWidth
        boothDepth
        boothHeight
        boothDimensionFile {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        booth3DModel {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        bundleBoothAvaiableAccessoriesId
        bundleBoothIncludedAccessoriesId
        productCategoryProductsId
        __typename
      }
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAvailableProductsInEvents = /* GraphQL */ `
  query ListAvailableProductsInEvents(
    $filter: ModelAvailableProductsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAvailableProductsInEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        eventId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const availableProductsInEventsByProductId = /* GraphQL */ `
  query AvailableProductsInEventsByProductId(
    $productId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailableProductsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availableProductsInEventsByProductId(
      productId: $productId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        eventId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const availableProductsInEventsByEventId = /* GraphQL */ `
  query AvailableProductsInEventsByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailableProductsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availableProductsInEventsByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        productId
        eventId
        product {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIndustryEvents = /* GraphQL */ `
  query GetIndustryEvents($id: ID!) {
    getIndustryEvents(id: $id) {
      id
      industryId
      eventId
      industry {
        id
        name {
          language
          text
          __typename
        }
        subTitle {
          language
          text
          __typename
        }
        handle
        domain
        notificationEmailAddress
        primaryColor
        secondaryColor
        logo {
          fileName
          alt
          x4UUID
          __typename
        }
        favicon {
          fileName
          alt
          x4UUID
          __typename
        }
        sortKey
        status
        socialLinks {
          facebook
          x
          instagram
          spotify
          linkedin
          xing
          youtube
          pinterest
          snapchat
          tiktok
          __typename
        }
        events {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        orders {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        jetEngineAccess {
          baseurl
          username
          password
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIndustryEvents = /* GraphQL */ `
  query ListIndustryEvents(
    $filter: ModelIndustryEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIndustryEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        industryId
        eventId
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const industryEventsByIndustryId = /* GraphQL */ `
  query IndustryEventsByIndustryId(
    $industryId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industryEventsByIndustryId(
      industryId: $industryId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        industryId
        eventId
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const industryEventsByEventId = /* GraphQL */ `
  query IndustryEventsByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelIndustryEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    industryEventsByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        industryId
        eventId
        industry {
          id
          handle
          domain
          notificationEmailAddress
          primaryColor
          secondaryColor
          sortKey
          status
          createdAt
          updatedAt
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCompaniesAttendingEvents = /* GraphQL */ `
  query GetCompaniesAttendingEvents($id: ID!) {
    getCompaniesAttendingEvents(id: $id) {
      id
      companyId
      eventId
      company {
        id
        name
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        shortDescription {
          language
          text
          __typename
        }
        industry
        status
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        website
        image {
          __typename
        }
        banner {
          fileName
          alt
          x4UUID
          __typename
        }
        departments {
          nextToken
          __typename
        }
        attendingEvents {
          nextToken
          __typename
        }
        employees {
          nextToken
          __typename
        }
        employmentRequests {
          nextToken
          __typename
        }
        admin {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        adminEmployees {
          nextToken
          __typename
        }
        admins
        x4Id
        x4AdminId
        todos {
          nextToken
          __typename
        }
        news {
          nextToken
          __typename
        }
        products {
          nextToken
          __typename
        }
        jobs {
          nextToken
          __typename
        }
        topics {
          nextToken
          __typename
        }
        keywords
        lectures {
          nextToken
          __typename
        }
        billingContact {
          phone
          mobile
          fax
          email
          __typename
        }
        billingSettings {
          orderNumberRequired
          __typename
        }
        orders {
          nextToken
          __typename
        }
        tourRegistrations {
          nextToken
          __typename
        }
        tourVisitorRegistrations {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        stockReservations {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyAdminId
        __typename
      }
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompaniesAttendingEvents = /* GraphQL */ `
  query ListCompaniesAttendingEvents(
    $filter: ModelCompaniesAttendingEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompaniesAttendingEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        eventId
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companiesAttendingEventsByCompanyId = /* GraphQL */ `
  query CompaniesAttendingEventsByCompanyId(
    $companyId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesAttendingEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesAttendingEventsByCompanyId(
      companyId: $companyId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        eventId
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const companiesAttendingEventsByEventId = /* GraphQL */ `
  query CompaniesAttendingEventsByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCompaniesAttendingEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    companiesAttendingEventsByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        companyId
        eventId
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeDepartments = /* GraphQL */ `
  query GetEmployeeDepartments($id: ID!) {
    getEmployeeDepartments(id: $id) {
      id
      employeeId
      departmentId
      employee {
        id
        user {
          owner
          id
          email
          firstName
          middleName
          lastName
          salutation
          title
          birthday
          personalIndustry
          personalDepartment
          language
          x4Id
          pw_hash
          hasCompletedOnboarding
          status
          hasInsightAccess
          createdAt
          updatedAt
          seminarSpeakersId
          __typename
        }
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        department {
          nextToken
          __typename
        }
        contact {
          phone
          mobile
          fax
          email
          __typename
        }
        role
        permissions {
          resource
          actions
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        x4Id
        News {
          nextToken
          __typename
        }
        WPJetEngineId
        lectures {
          nextToken
          __typename
        }
        userCognitoId
        tourRegistrations {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        companyEmployeesId
        companyAdminEmployeesId
        userEmployeeProfilesId
        __typename
      }
      department {
        id
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        status
        company {
          id
          name
          slug
          slugHistory
          industry
          status
          website
          admins
          x4Id
          x4AdminId
          keywords
          createdAt
          updatedAt
          companyAdminId
          __typename
        }
        employees {
          nextToken
          __typename
        }
        x4Name
        createdAt
        updatedAt
        companyDepartmentsId
        __typename
      }
      createdAt
      updatedAt
      userCognitoId
      __typename
    }
  }
`;
export const listEmployeeDepartments = /* GraphQL */ `
  query ListEmployeeDepartments(
    $filter: ModelEmployeeDepartmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeDepartments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        departmentId
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        department {
          id
          status
          x4Name
          createdAt
          updatedAt
          companyDepartmentsId
          __typename
        }
        createdAt
        updatedAt
        userCognitoId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeDepartmentsByEmployeeId = /* GraphQL */ `
  query EmployeeDepartmentsByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeDepartmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeDepartmentsByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        departmentId
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        department {
          id
          status
          x4Name
          createdAt
          updatedAt
          companyDepartmentsId
          __typename
        }
        createdAt
        updatedAt
        userCognitoId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeDepartmentsByDepartmentId = /* GraphQL */ `
  query EmployeeDepartmentsByDepartmentId(
    $departmentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeDepartmentsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeDepartmentsByDepartmentId(
      departmentId: $departmentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        departmentId
        employee {
          id
          role
          status
          x4Id
          WPJetEngineId
          userCognitoId
          createdAt
          updatedAt
          companyEmployeesId
          companyAdminEmployeesId
          userEmployeeProfilesId
          __typename
        }
        department {
          id
          status
          x4Name
          createdAt
          updatedAt
          companyDepartmentsId
          __typename
        }
        createdAt
        updatedAt
        userCognitoId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAvailableCarpetsInEvents = /* GraphQL */ `
  query GetAvailableCarpetsInEvents($id: ID!) {
    getAvailableCarpetsInEvents(id: $id) {
      id
      eventId
      eventCarpetId
      event {
        id
        type
        boothBooking
        boothBookingStart
        boothBookingEnd
        name {
          language
          text
          __typename
        }
        slug
        slugHistory
        description {
          language
          text
          __typename
        }
        status
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        date
        startDate
        endDate
        startTime
        endTime
        daySchedules {
          day
          date
          exhibitorStart
          exhibitorEnd
          visitorStart
          visitorEnd
          __typename
        }
        location {
          __typename
        }
        lectureRooms
        lectureRegistrationStartDate
        lectureRegistrationEndDate
        lectureEditEndDate
        lectureDocumentsEndDate
        lecturePresentationEndDate
        lectureRecordingCorrectionEndDate
        actionRegistrationStartDate
        actionRegistrationEndDate
        actionEditEndDate
        deadlineBoothEquipmentPrint
        carpetColorSelectionEndDate
        startBoothEquipmentBooking
        deadlineBoothEquipmentBooking
        startBoothMarketingBooking
        deadlineBoothMarketingBooking
        availableLectureTypes
        floorPlan {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        boothPlan {
          width
          height
          areasUpdatedAt
          viewBox
          activeVersionId
          __typename
        }
        program {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        landingPageUrl
        attendees {
          nextToken
          __typename
        }
        availableBundleBooths {
          nextToken
          __typename
        }
        availableProducts {
          nextToken
          __typename
        }
        ticketProduct {
          id
          visibleInShop
          name_text
          sku
          ean
          type
          subType
          price
          downPaymentPrice
          allowedBuyerGroups
          requiredShipping
          icon
          stock
          boothNumber
          boothVariant
          boothVariantAliases
          boothMatchRule
          boothPriceMode
          boothPriceRule
          boothArea
          boothWidth
          boothDepth
          boothHeight
          createdAt
          updatedAt
          bundleBoothAvaiableAccessoriesId
          bundleBoothIncludedAccessoriesId
          productCategoryProductsId
          __typename
        }
        eventProducts {
          nextToken
          __typename
        }
        lectures {
          nextToken
          __typename
        }
        tours {
          nextToken
          __typename
        }
        invitationCodes {
          nextToken
          __typename
        }
        bookedBooths {
          nextToken
          __typename
        }
        availableCarpets {
          nextToken
          __typename
        }
        highlightedPersons {
          userid
          __typename
        }
        industries {
          nextToken
          __typename
        }
        x4Id
        WPJetEngineId
        orders {
          nextToken
          __typename
        }
        publicVideos
        bookingTicketBulletPoints {
          __typename
        }
        hasInvitationCodes
        invitationCodeRequired
        suggestedInvitationCode
        badgePreview {
          fileName
          alt
          x4UUID
          __typename
        }
        bookingSelectDays
        ticketTAC {
          language
          text
          __typename
        }
        ticketPrivacyPolicy {
          language
          text
          __typename
        }
        boothTAC {
          language
          text
          __typename
        }
        boothPrivacyPolicy {
          language
          text
          __typename
        }
        instantPaymentOnly
        autoGenerateInvoice
        paymentFlow
        ticketPricePerDay
        enableTicketBooking
        enableStaffBooking
        allowCompanyToBookTickets
        ticketCancellationDeadline
        ticketNotice {
          language
          text
          __typename
        }
        ticketOrganizerLine {
          language
          text
          __typename
        }
        bookingNotice {
          language
          text
          __typename
        }
        exhibitorLectures
        lecturesNotice {
          language
          text
          __typename
        }
        landingPageIntroText {
          language
          text
          __typename
        }
        landingPageProgramText {
          language
          text
          __typename
        }
        landingPageProgramSpeakersTitle {
          language
          text
          __typename
        }
        landingPageProgramSpeakersText {
          language
          text
          __typename
        }
        landingPageBookingText {
          language
          text
          __typename
        }
        landingPageBookingPandCText {
          language
          text
          __typename
        }
        heroBannerStats {
          language
          text
          __typename
        }
        infoTextExhibitors {
          language
          text
          __typename
        }
        infoTextVisitors {
          language
          text
          __typename
        }
        infoTextTravel {
          language
          text
          __typename
        }
        contactPersons {
          name
          department
          phone
          email
          __typename
        }
        documents {
          url
          publicUrl
          s3Path
          fileName
          type
          name
          createdAt
          updatedAt
          __typename
        }
        highlights {
          __typename
        }
        createdAt
        updatedAt
        eventTicketProductId
        __typename
      }
      eventCarpet {
        id
        order
        name {
          language
          text
          __typename
        }
        description {
          language
          text
          __typename
        }
        color
        image {
          fileName
          alt
          x4UUID
          __typename
        }
        availableInEvents {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAvailableCarpetsInEvents = /* GraphQL */ `
  query ListAvailableCarpetsInEvents(
    $filter: ModelAvailableCarpetsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAvailableCarpetsInEvents(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        eventCarpetId
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        eventCarpet {
          id
          order
          color
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const availableCarpetsInEventsByEventId = /* GraphQL */ `
  query AvailableCarpetsInEventsByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailableCarpetsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availableCarpetsInEventsByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        eventCarpetId
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        eventCarpet {
          id
          order
          color
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const availableCarpetsInEventsByEventCarpetId = /* GraphQL */ `
  query AvailableCarpetsInEventsByEventCarpetId(
    $eventCarpetId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAvailableCarpetsInEventsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    availableCarpetsInEventsByEventCarpetId(
      eventCarpetId: $eventCarpetId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        eventCarpetId
        event {
          id
          type
          boothBooking
          boothBookingStart
          boothBookingEnd
          slug
          slugHistory
          status
          date
          startDate
          endDate
          startTime
          endTime
          lectureRooms
          lectureRegistrationStartDate
          lectureRegistrationEndDate
          lectureEditEndDate
          lectureDocumentsEndDate
          lecturePresentationEndDate
          lectureRecordingCorrectionEndDate
          actionRegistrationStartDate
          actionRegistrationEndDate
          actionEditEndDate
          deadlineBoothEquipmentPrint
          carpetColorSelectionEndDate
          startBoothEquipmentBooking
          deadlineBoothEquipmentBooking
          startBoothMarketingBooking
          deadlineBoothMarketingBooking
          availableLectureTypes
          landingPageUrl
          x4Id
          WPJetEngineId
          publicVideos
          hasInvitationCodes
          invitationCodeRequired
          suggestedInvitationCode
          bookingSelectDays
          instantPaymentOnly
          autoGenerateInvoice
          paymentFlow
          ticketPricePerDay
          enableTicketBooking
          enableStaffBooking
          allowCompanyToBookTickets
          ticketCancellationDeadline
          exhibitorLectures
          createdAt
          updatedAt
          eventTicketProductId
          __typename
        }
        eventCarpet {
          id
          order
          color
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
